[
  {
    "id": 250,
    "uuid": "cfb74610-0162-4438-8df9-ac0a42f72a62",
    "hitokoto": "我裤子都脱了你就给我看这个！！！",
    "type": "g",
    "from": "2ch",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605920",
    "length": 16
  },
  {
    "id": 463,
    "uuid": "523800f2-1945-4299-b6f5-3944a6f08b8f",
    "hitokoto": "臣妾做不到啊~",
    "type": "g",
    "from": "甄嬛传",
    "from_who": null,
    "creator": "mlmtmfz",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950837",
    "length": 7
  },
  {
    "id": 464,
    "uuid": "2c112e80-d120-4fa9-af62-eb19c90f1412",
    "hitokoto": "我爱上的人，称我为怪叔叔",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "1263",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950837",
    "length": 12
  },
  {
    "id": 465,
    "uuid": "c9800855-1a88-4c2b-a65c-12eeff38eed8",
    "hitokoto": "要么忙着生存要么赶着去死，人总要做点什么。",
    "type": "g",
    "from": "肖申克的救赎",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950838",
    "length": 21
  },
  {
    "id": 466,
    "uuid": "4afc275f-0277-47c8-9c00-10a39e4b0331",
    "hitokoto": "不管怎么样，未来都是可以改变的。",
    "type": "g",
    "from": "雏菊",
    "from_who": null,
    "creator": "xi4oh4o",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950838",
    "length": 16
  },
  {
    "id": 467,
    "uuid": "613a8c30-8458-459b-9abf-06b33acefb56",
    "hitokoto": "你需要找出面对明天的力量。",
    "type": "g",
    "from": "The Battle of Chernobyl",
    "from_who": null,
    "creator": "xi4oh4o",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950838",
    "length": 13
  },
  {
    "id": 468,
    "uuid": "7d2d5070-2bf7-4559-9712-fe7f0ebd17ab",
    "hitokoto": "Yesterday is a history, tomorrow is a mystery, but today is a gift.",
    "type": "g",
    "from": "功夫熊猫",
    "from_who": null,
    "creator": "efreet",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950839",
    "length": 67
  },
  {
    "id": 469,
    "uuid": "d2a2af7b-9745-4c67-b8c2-f84e9a7e4ace",
    "hitokoto": "握不住的沙，不如扬了它。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "枫丶牙",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950839",
    "length": 12
  },
  {
    "id": 470,
    "uuid": "f22e2d77-b838-4c6f-b99c-ac3decb90ca9",
    "hitokoto": "文能提笔控萝莉，武能床上定人妻。进可欺身压正太，退能提臀迎众基。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "Wesion",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950840",
    "length": 32
  },
  {
    "id": 471,
    "uuid": "29eefca5-9a8f-41a5-a54a-51892e14133c",
    "hitokoto": "慕君之心，至死方休。",
    "type": "g",
    "from": "孟子",
    "from_who": null,
    "creator": "wwwwodddd",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950840",
    "length": 10
  },
  {
    "id": 472,
    "uuid": "6e082921-809e-4f4a-83f7-a78799e6b05f",
    "hitokoto": "我们一路奋战，不是为了改变世界，而是为了不让世界改变我们。",
    "type": "g",
    "from": "熔炉",
    "from_who": null,
    "creator": "928884975",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950841",
    "length": 29
  },
  {
    "id": 473,
    "uuid": "8a120d28-6817-4285-9080-5ea1d7606bfd",
    "hitokoto": "面对无知的嘲笑，我只能为他们默哀。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "星之彼岸",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950841",
    "length": 17
  },
  {
    "id": 474,
    "uuid": "f8f79844-960e-4720-a7d2-2e89296ce177",
    "hitokoto": "不要因为结束而哭泣，微笑吧，为你的曾经拥有。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "han",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950841",
    "length": 22
  },
  {
    "id": 475,
    "uuid": "bc7491c2-4f7d-4024-9e80-4c46df5484e6",
    "hitokoto": "既然忘不掉，就把它留在心中，让时间去冲淡它。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "chen970213",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950842",
    "length": 22
  },
  {
    "id": 476,
    "uuid": "7601bbef-a8a5-4d04-929e-05d07d0e793d",
    "hitokoto": "君生我未生，我生君已老。 君恨我生迟，我恨君生早。",
    "type": "g",
    "from": "全唐诗续拾",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950842",
    "length": 25
  },
  {
    "id": 477,
    "uuid": "af49267e-5e43-4553-a934-7b84f6b7892d",
    "hitokoto": "我从小就害怕虫子",
    "type": "g",
    "from": "小小闲",
    "from_who": null,
    "creator": "firo",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950842",
    "length": 8
  },
  {
    "id": 478,
    "uuid": "0de40994-c264-46b2-bfbe-8e76e055464f",
    "hitokoto": "缘起，在人群中，我看见你。缘灭，我看见你，在人群中。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "泣幽寂",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950845",
    "length": 26
  },
  {
    "id": 479,
    "uuid": "05f790b7-527b-4aa3-9112-365e061cfa25",
    "hitokoto": "透过孩子的眼神，让我相信这个世界上还有着纯真。",
    "type": "g",
    "from": "宫崎骏",
    "from_who": null,
    "creator": "anythink",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950861",
    "length": 23
  },
  {
    "id": 480,
    "uuid": "9d161d20-9dd7-4ff3-b918-3d02f4f43db4",
    "hitokoto": "Hello World!",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468950862",
    "length": 12
  },
  {
    "id": 487,
    "uuid": "75660742-b70d-4178-b537-687375952f13",
    "hitokoto": "古之立大事者，不惟有超世之才，亦必有坚忍不拔之志。",
    "type": "g",
    "from": "晁错论",
    "from_who": null,
    "creator": "freejishu",
    "creator_uid": 1,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1471865209",
    "length": 25
  },
  {
    "id": 489,
    "uuid": "302940d4-7b08-41bb-afc5-122fb4b5c6e3",
    "hitokoto": "我曾经失落失望失掉所有方向，直到看见平凡才是唯一的答案。",
    "type": "g",
    "from": "平凡之路",
    "from_who": null,
    "creator": "freejishu",
    "creator_uid": 1,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1471870474",
    "length": 28
  },
  {
    "id": 492,
    "uuid": "beb69b86-21d7-41d2-84fd-84f9734fc5c4",
    "hitokoto": "学而不思则罔，思而不学则殆。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435289",
    "length": 14
  },
  {
    "id": 493,
    "uuid": "881aa669-acf9-44e2-af30-40c66b0c0bf5",
    "hitokoto": "岁寒，然后知松柏之后凋也。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435281",
    "length": 13
  },
  {
    "id": 494,
    "uuid": "9d002ad8-c577-43fb-a632-2c63dcb02181",
    "hitokoto": "君子坦荡荡，小人长戚戚。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435271",
    "length": 12
  },
  {
    "id": 495,
    "uuid": "d05bc45d-736c-46e1-8e24-c0aee5824abc",
    "hitokoto": "工欲善其事，必先利其器。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435263",
    "length": 12
  },
  {
    "id": 496,
    "uuid": "105c53d4-fd5c-4f28-841c-590f952ce6d8",
    "hitokoto": "己所不欲，勿施于人。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435255",
    "length": 10
  },
  {
    "id": 497,
    "uuid": "431a7e88-4823-4a96-a436-29bc2cbe8457",
    "hitokoto": "敏而好学，不耻下问。",
    "type": "g",
    "from": "论语",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435245",
    "length": 10
  },
  {
    "id": 498,
    "uuid": "99dff903-fd5d-4f41-bb6f-f0ee69dac6f3",
    "hitokoto": "合抱之木，生于毫末；九层之台，起于累土；千里之行，始于足下。",
    "type": "g",
    "from": "老子",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435238",
    "length": 30
  },
  {
    "id": 499,
    "uuid": "ebad4462-54d4-4f28-b477-066d18c4f28d",
    "hitokoto": "祸兮福之所倚，福兮祸之所伏。",
    "type": "g",
    "from": "鵩鸟赋",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435232",
    "length": 14
  },
  {
    "id": 500,
    "uuid": "410b2722-7a02-43ed-9a75-46081bf3c9ba",
    "hitokoto": "信言不美，美言不信。",
    "type": "g",
    "from": "老子",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435224",
    "length": 10
  },
  {
    "id": 501,
    "uuid": "c504f32b-5458-4bf7-a331-4e0b1a0ebd37",
    "hitokoto": "知人者智，自知者明。",
    "type": "g",
    "from": "老子",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435215",
    "length": 10
  },
  {
    "id": 502,
    "uuid": "d7bca85d-dcdf-4581-9966-74d9e5909d7d",
    "hitokoto": "人非圣贤，孰能无过？过而能改，善莫大焉。",
    "type": "g",
    "from": "左传",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435207",
    "length": 20
  },
  {
    "id": 503,
    "uuid": "f04463d9-4e9a-453d-89fd-d4d219da16a3",
    "hitokoto": "居安思危，思则有备，有备无患。",
    "type": "g",
    "from": "左传",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435196",
    "length": 15
  },
  {
    "id": 504,
    "uuid": "2f236b9a-4030-4843-bb8e-561d7baba658",
    "hitokoto": "多行不义必自毙。",
    "type": "g",
    "from": "左传",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435185",
    "length": 8
  },
  {
    "id": 505,
    "uuid": "fd350561-53e8-4582-afe7-dbe23a14c6c2",
    "hitokoto": "从善如登，从恶如崩。",
    "type": "g",
    "from": "国语·周语下",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435177",
    "length": 10
  },
  {
    "id": 506,
    "uuid": "6f8280b8-d16f-4cb9-a005-320ee461aa83",
    "hitokoto": "投我以桃，报之以李。",
    "type": "g",
    "from": "诗经",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435151",
    "length": 10
  },
  {
    "id": 507,
    "uuid": "ca1f3a3e-4a11-4bfa-bff5-b1324e008b12",
    "hitokoto": "他山之石，可以攻玉。",
    "type": "g",
    "from": "诗经·小雅",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435143",
    "length": 10
  },
  {
    "id": 508,
    "uuid": "ce491b2c-6f62-42f9-b280-ed4a2f574edb",
    "hitokoto": "言者无罪，闻者足戒。",
    "type": "g",
    "from": "诗经·周南·关雎·序",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435132",
    "length": 10
  },
  {
    "id": 509,
    "uuid": "60a46c8e-454f-4393-a8d2-c205e6f8b217",
    "hitokoto": "人而无仪，不死何为!",
    "type": "g",
    "from": "相鼠",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435121",
    "length": 10
  },
  {
    "id": 510,
    "uuid": "3b0850ba-e7bb-44e7-81ae-1e0c87ce435f",
    "hitokoto": "天作孽，犹可违，自作孽，不可活。",
    "type": "g",
    "from": "尚书·太甲",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435160",
    "length": 16
  },
  {
    "id": 511,
    "uuid": "85e0bd7a-0fab-4719-9b56-21a34776b2f1",
    "hitokoto": "满招损，谦受益。",
    "type": "g",
    "from": "尚书·大禹谟",
    "from_who": null,
    "creator": "小强",
    "creator_uid": 11,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472435170",
    "length": 8
  },
  {
    "id": 667,
    "uuid": "97c9684f-b85f-47eb-b180-5c1e81bb8c4a",
    "hitokoto": "我无处不在",
    "type": "g",
    "from": "超体",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475412278",
    "length": 5
  },
  {
    "id": 668,
    "uuid": "99d96f60-cfc0-4a3d-8937-363ad8a6bfc7",
    "hitokoto": "自己珍视的事物，自己珍视的人，自己最真实的希望，想要一路坚持到底，全力让此刻绽放光芒，实现吧，大家的梦想！",
    "type": "g",
    "from": "千反田⑨的绘马",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475508758",
    "length": 53
  },
  {
    "id": 669,
    "uuid": "ea7675bb-df14-4c75-b740-a36394707c8e",
    "hitokoto": "为了能再什么时候让9人配音而继续画下去是我应该做的。 非常非常非常棒的final live真的谢谢了!!!",
    "type": "g",
    "from": "室田雄平",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475508707",
    "length": 53
  },
  {
    "id": 670,
    "uuid": "bd5a272b-f2dc-45c4-994e-cb3f35180171",
    "hitokoto": "一进，一跳！",
    "type": "g",
    "from": "绚濑绘里",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475397902",
    "length": 6
  },
  {
    "id": 671,
    "uuid": "a3c760f2-c362-4db2-a013-9c5b03070025",
    "hitokoto": "夏天！泳装！并且……欢跃而起！！",
    "type": "g",
    "from": "畑亚贵",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475393716",
    "length": 16
  },
  {
    "id": 672,
    "uuid": "6d85ce43-0869-487f-b174-bfcee556b38d",
    "hitokoto": "使会场合而为一的歌曲。大家一起飞起来吧!",
    "type": "g",
    "from": "南条爱乃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475397842",
    "length": 20
  },
  {
    "id": 674,
    "uuid": "065efe96-e742-441e-a3f1-1f63ee38989d",
    "hitokoto": "大家所做的，最棒的 LIVE ！",
    "type": "g",
    "from": "SUNNY DAY SONG",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475517785",
    "length": 16
  },
  {
    "id": 677,
    "uuid": "42528080-ee44-4226-8f4c-977aeaac31f5",
    "hitokoto": "スキスキぷわぷわスキスキぷわぷわ！わしちゃおう!",
    "type": "g",
    "from": "Printemps",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475607541",
    "length": 24
  },
  {
    "id": 702,
    "uuid": "9c636cdb-a8cd-4b57-b671-3851148081a1",
    "hitokoto": "陪着你做前端",
    "type": "g",
    "from": "萌芽",
    "from_who": null,
    "creator": "萌芽",
    "creator_uid": 81,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476952003",
    "length": 6
  },
  {
    "id": 703,
    "uuid": "c3dae181-5222-493e-93ea-4a7b484e1d42",
    "hitokoto": "无奈夜长人不寐，数声和月到帘栊。",
    "type": "g",
    "from": "捣练子令",
    "from_who": null,
    "creator": "″如叶般凋零。",
    "creator_uid": 87,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477218140",
    "length": 16
  },
  {
    "id": 704,
    "uuid": "b97ae91b-a403-4f78-b83f-d7f60afcb9fc",
    "hitokoto": "浅情终似，行云无定，犹到梦魂中。",
    "type": "g",
    "from": "少年游·离多最是",
    "from_who": null,
    "creator": "″如叶般凋零。",
    "creator_uid": 87,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477218298",
    "length": 16
  },
  {
    "id": 705,
    "uuid": "7058b89c-d2e4-420b-b82b-4d4322067cd9",
    "hitokoto": "可怜人意，薄于云水，佳会更难重。",
    "type": "g",
    "from": "少年游·离多最是",
    "from_who": null,
    "creator": "″如叶般凋零。",
    "creator_uid": 87,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477218402",
    "length": 16
  },
  {
    "id": 716,
    "uuid": "4d351013-71b4-4457-bd91-a1e41e3a75c3",
    "hitokoto": "多一分心力去注意别人，就少一分心力反省自己，你懂吗？",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 721,
    "uuid": "d885a844-d309-4b4f-b5e7-5b864f14c27b",
    "hitokoto": "春风得意马蹄疾,一日看尽长安花.",
    "type": "g",
    "from": "登科后",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 723,
    "uuid": "54a77efd-075f-4b41-8139-2165b8a85f7a",
    "hitokoto": "你的胆小，就让它，见鬼去吧。",
    "type": "g",
    "from": "アシタハアタシノカゼガフク",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 14
  },
  {
    "id": 730,
    "uuid": "cf7cb074-20f2-45b2-9487-148019bc8d06",
    "hitokoto": "万法缘生，皆系缘分！",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 737,
    "uuid": "518a04b4-b036-40ad-b149-ed17a32fd441",
    "hitokoto": "就算这全世界 都将与你为敌 我也会守护你 所以你只需要在那微笑就好",
    "type": "g",
    "from": "镜音リン",
    "from_who": "悪丿召使",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 33
  },
  {
    "id": 747,
    "uuid": "bfd8ef2f-070e-4915-ad07-f45e28dcfd25",
    "hitokoto": "有一个面包,走着走着肚饿了,于是就把自己吃了",
    "type": "g",
    "from": "冷笑话",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 755,
    "uuid": "e6d55b78-1bc0-4cd7-b820-ac6dc02a2b92",
    "hitokoto": "如果政府不能解决问题, 那它本身就成为问题!",
    "type": "g",
    "from": "里根",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 760,
    "uuid": "c0124a5c-1c2c-4c12-b3cd-bb2e3124665b",
    "hitokoto": "衣带渐宽终不悔,为伊消得人憔悴.",
    "type": "g",
    "from": "蝶恋花",
    "from_who": "柳永",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 764,
    "uuid": "fe71853c-6376-4059-b570-7fd8be434639",
    "hitokoto": "Just give me that chance.",
    "type": "g",
    "from": "肖申克的救赎",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 769,
    "uuid": "3479a6c9-4774-424d-ac7c-0226318600d7",
    "hitokoto": "举手长劳劳,二情同依依.",
    "type": "g",
    "from": "孔雀东南飞",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 771,
    "uuid": "d5fcb025-b91c-43e8-b08b-494d29de9e37",
    "hitokoto": "世间所有的相遇，都是久别重逢。",
    "type": "g",
    "from": "一代宗师",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 776,
    "uuid": "8fabd2b3-2bef-4dae-a37d-d1919fbe2fcc",
    "hitokoto": "斜晖脉脉水悠悠,肠断白频洲.",
    "type": "g",
    "from": "望江南",
    "from_who": "温庭筠",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 14
  },
  {
    "id": 779,
    "uuid": "147a3b12-06be-4896-9a46-ea32baa4cbce",
    "hitokoto": "要么忙着生存要么赶着去死，人总要做点什么",
    "type": "g",
    "from": "肖申克的救赎",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 782,
    "uuid": "fffa7498-8d1a-49d0-8037-3dc660db6a91",
    "hitokoto": "如何得与凉风约，不共尘沙一并来！",
    "type": "g",
    "from": "中牟道中",
    "from_who": "陈与义",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 787,
    "uuid": "24e6e1e9-e344-43e2-a41d-8dbef5cc13ad",
    "hitokoto": "说时依旧,有泪如倾",
    "type": "g",
    "from": "说时依旧",
    "from_who": "三毛",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 9
  },
  {
    "id": 790,
    "uuid": "88aab2d5-aebd-4a16-882b-28a73c69d651",
    "hitokoto": "无论做什么，记得为自己而做，那就毫无怨言。",
    "type": "g",
    "from": "流金岁月",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 791,
    "uuid": "92cbfd64-22e0-4ac8-a83e-6ea6c7171e62",
    "hitokoto": "茕茕白兔，东走西顾。衣不如新，人不如故。",
    "type": "g",
    "from": "古艳歌",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 796,
    "uuid": "dd193179-59d8-4937-8aa6-9d982940525c",
    "hitokoto": "给生命以时间，而不是给时间以生命。",
    "type": "g",
    "from": "思想录",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 801,
    "uuid": "1fe013db-dd5a-4cb1-9b2b-82b49ea52d47",
    "hitokoto": "一个人有一个故事，别让你的故事留白。",
    "type": "g",
    "from": "Jack Daniels Whisky",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 805,
    "uuid": "9379da42-c7c8-4f6f-ab1a-f18e24e77ba7",
    "hitokoto": "悲伤可以自行料理;而欢乐的滋味如果要充分体会，你就必须有人分享才行。",
    "type": "g",
    "from": "马克·吐温",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 34
  },
  {
    "id": 806,
    "uuid": "bd04dd07-36b5-422b-8d7f-117d19e7c430",
    "hitokoto": "你的笑容怡人如晚霞般，在川流不息的时光中，神采飞扬。",
    "type": "g",
    "from": " 时光",
    "from_who": "许巍",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 807,
    "uuid": "54b85ce6-ec8e-4b36-b18e-0dfcc9f6b5e0",
    "hitokoto": "光明只是短暂的一瞬，黑暗才是永恒的，但正是这短暂一瞬的光芒，诞生了生命与希望。",
    "type": "g",
    "from": "藏地密码",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 39
  },
  {
    "id": 810,
    "uuid": "69d39be9-b14b-4215-937d-0426b02c2ed6",
    "hitokoto": "人生的真理，只是藏在平淡无味之中。",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 814,
    "uuid": "0a011948-2e86-4924-95a7-3d06c3d9f4c9",
    "hitokoto": "愿我的人民，永远，不要被那些无关紧要的差别，所迷惑。",
    "type": "g",
    "from": "魔兽",
    "from_who": "萨尔",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 817,
    "uuid": "ecf36b62-77db-4abf-853b-d7ff1f9e289c",
    "hitokoto": "不要跟过去的自己比，要期待未来的自己，珍爱现在的自己。",
    "type": "g",
    "from": "主君的太阳",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 27
  },
  {
    "id": 821,
    "uuid": "bde2c7e0-ce12-4876-a798-d1a2342f2823",
    "hitokoto": "积土而为山，积水而为海。",
    "type": "g",
    "from": "荀子·儒效",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 822,
    "uuid": "7da3a124-9cd6-4770-a9eb-4aa483ca3fea",
    "hitokoto": "你看，那个人好像一只狗诶。",
    "type": "g",
    "from": "大话西游之大圣娶亲",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 826,
    "uuid": "1941f6f2-c3ac-4ce4-8de7-d3d9a56bb43d",
    "hitokoto": "如今这里荒草丛生没有了鲜花，好在曾今拥有你们的春秋和冬夏。",
    "type": "g",
    "from": "那些花儿",
    "from_who": "朴树 ",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 29
  },
  {
    "id": 827,
    "uuid": "94ded6ea-df4d-4eaa-bd9e-6c512a92c8c1",
    "hitokoto": "如果你在的时候,会不会伸手拥抱我",
    "type": "g",
    "from": "星空",
    "from_who": "五月天",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 828,
    "uuid": "c97ba0af-1dd6-4f79-a894-c01ea53f1646",
    "hitokoto": "時をまきもどしてみるかい？",
    "type": "g",
    "from": "僕たちはひとつの光",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 835,
    "uuid": "aa142a0d-323f-4f75-a3f5-f9ebf44397bf",
    "hitokoto": "生活越来越压抑 你变得越来越不像自己 玫瑰你在哪里 你总是喜欢抓不住的东西",
    "type": "g",
    "from": "玫瑰",
    "from_who": "贰佰",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 853,
    "uuid": "21966806-ca30-40fd-a308-246a8952d4bc",
    "hitokoto": "竟有如此美丽的结构存在",
    "type": "g",
    "from": "詹姆斯·杜威·沃森",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 858,
    "uuid": "1ae384a9-0c12-4870-aed8-d3e7d48d1596",
    "hitokoto": "五十年来和五百年内，中国写猴子的前三名都是我、我、我。",
    "type": "g",
    "from": "今何在",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 27
  },
  {
    "id": 864,
    "uuid": "6545a3d9-155f-49dc-98b4-8c70904e5160",
    "hitokoto": "你骄傲的和别人说，嘿，我写了个能让Windows崩溃的程序，他们会面无表情地盯着你说“哥们，我装（Windows）系统的时候就免费带着了”",
    "type": "g",
    "from": "李纳斯",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 69
  },
  {
    "id": 872,
    "uuid": "71b7a0b2-a5cf-4640-8853-29e3c3442205",
    "hitokoto": "忌妒别人，不会给自己增加任何的好处。忌妒别人，也不可能减少别人的成就。",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 35
  },
  {
    "id": 875,
    "uuid": "18a3281d-9dc3-433d-aca6-5e50b753dc62",
    "hitokoto": "Sunny day Wow! Song power!",
    "type": "g",
    "from": "SUNNY DAY SONG",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 886,
    "uuid": "7b491319-c793-4b47-acc0-56e538eebea8",
    "hitokoto": "牺牲基本自由来换取暂时的安全, 最后既得不到安全也得不到自由!",
    "type": "g",
    "from": "本杰明.富兰克林",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 31
  },
  {
    "id": 890,
    "uuid": "3cfa2bde-1fe2-42f7-a3b3-fa0cbabfbc9b",
    "hitokoto": "这世界是个好地方，值得为它奋斗。后半句我同意。",
    "type": "g",
    "from": "海明威",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 23
  },
  {
    "id": 891,
    "uuid": "a1fd9e40-a1ee-48f1-9f1e-5979a9c74d7e",
    "hitokoto": "成熟不是心变老,是泪在打转还能微笑",
    "type": "g",
    "from": "天边",
    "from_who": "张韶涵",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 892,
    "uuid": "55c8484a-9640-4990-938c-c0bae2e29c7f",
    "hitokoto": "如果我们就这样死在山里面 他们会不会说我们是殉情",
    "type": "g",
    "from": "星空",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 24
  },
  {
    "id": 895,
    "uuid": "b2bcfdd9-b58d-4399-850c-41831cc01aa9",
    "hitokoto": "盈盈一水间,脉脉不得语.",
    "type": "g",
    "from": "迢迢牵牛星",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 897,
    "uuid": "9d92f986-c24b-4e95-811b-d5ea3be4695c",
    "hitokoto": "与君初相识，犹如故人归",
    "type": "g",
    "from": "茶花",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 899,
    "uuid": "7d16f048-210a-4f9b-8e68-9acdbd7d5038",
    "hitokoto": "如今我对自己故乡，像来往匆匆的过客。",
    "type": "g",
    "from": "家",
    "from_who": "许巍",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 900,
    "uuid": "3871cd0a-31d4-48a1-98c7-882a3174acf9",
    "hitokoto": "前不见古人,后不见来者.念天地之悠悠,独怆然而涕下.",
    "type": "g",
    "from": "登幽州台歌",
    "from_who": "陈子昂",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 904,
    "uuid": "4670359f-5eec-4cea-8e7c-d28ee81c7eb5",
    "hitokoto": "一念愚即般若绝，一念智即般若生。",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 916,
    "uuid": "0061b6b6-f7c4-4ae3-b3e1-f023b95a11d1",
    "hitokoto": "照我思索，可理解我，照我思索，可以得人。",
    "type": "g",
    "from": "沈从文墓志铭",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 920,
    "uuid": "43f1e7f1-490c-4964-ada0-585c923af62c",
    "hitokoto": "我知道这个世上有人在等我，尽管我不知道我在等谁。当因为这样，我每天都很快乐。",
    "type": "g",
    "from": "返老还童",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 38
  },
  {
    "id": 923,
    "uuid": "eeaa200d-094f-4edb-a8c8-c6fc123ec2bc",
    "hitokoto": "我从远方赶来，恰巧你们也在。",
    "type": "g",
    "from": "生如夏花",
    "from_who": "朴树",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 14
  },
  {
    "id": 926,
    "uuid": "71a435ca-2c89-4642-840b-6985de7f5161",
    "hitokoto": "街上照明光华璀璨 乙醚麻醉的冰冷 无法成眠的凌晨两点 一切事物快速地转变",
    "type": "g",
    "from": "炉心融解",
    "from_who": "镜音リン",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 36
  },
  {
    "id": 939,
    "uuid": "46835cd4-1a85-4079-a0b5-4e019f8df098",
    "hitokoto": "坐亦禅，行亦禅，一花一世界，一叶一如来，春来花自青，秋至叶飘零，无穷般若心自在，语默动静体自然。",
    "type": "g",
    "from": "佛教禅语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 48
  },
  {
    "id": 945,
    "uuid": "a7809edc-65b9-4b40-af08-d88ced5afb84",
    "hitokoto": "如果我的付出,可以为人类的未来增加一块基石的话,大概我就是为此而生的吧",
    "type": "g",
    "from": "徐逸",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 35
  },
  {
    "id": 947,
    "uuid": "1bf17bcb-1b96-4f96-b226-4a8cc23edca1",
    "hitokoto": "我已经倾尽所有了， 如果这次还不成功， 我就真的一无所有了， 到时候我会放弃， 我不会再固执了~",
    "type": "g",
    "from": "海苔亿万富翁 top secret",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 48
  },
  {
    "id": 954,
    "uuid": "52c45a2c-ca5b-4c27-b202-a110ad14fc65",
    "hitokoto": "天之苍苍，其正色邪？其远而无所至极邪？",
    "type": "g",
    "from": "逍遥游",
    "from_who": null,
    "creator": "LCloud",
    "creator_uid": 118,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479465452",
    "length": 19
  },
  {
    "id": 960,
    "uuid": "397a59e1-1d92-4fbd-a1ee-ff5e272480d4",
    "hitokoto": "死亡不是失去了生命，只是走出了时间",
    "type": "g",
    "from": "干嚼鹿肉",
    "from_who": null,
    "creator": "Hex Lee",
    "creator_uid": 107,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478853182",
    "length": 17
  },
  {
    "id": 967,
    "uuid": "3f7e6bb7-2cc3-4afa-8274-8acc517e602e",
    "hitokoto": "生活就像海洋，只有意志坚强的人，才能到达彼岸。",
    "type": "g",
    "from": "马克思",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480327930",
    "length": 23
  },
  {
    "id": 968,
    "uuid": "a6f9dabc-159d-4f5e-94a4-4aed37302bac",
    "hitokoto": "好目睫之利者，利在害中而不弃；好终身之利者，利在目睫而不为。",
    "type": "g",
    "from": "庄元臣",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480342803",
    "length": 30
  },
  {
    "id": 969,
    "uuid": "9a36ac26-301c-42e1-9a04-6b264f8fb0dc",
    "hitokoto": "不稼不穑，耕怠者无获；不了不当，事辍者无功。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480342525",
    "length": 22
  },
  {
    "id": 971,
    "uuid": "75585ddd-eae1-4b73-bb02-894aaa73667b",
    "hitokoto": "Write the code, Change the world.",
    "type": "g",
    "from": "Apple",
    "from_who": null,
    "creator": "Secret",
    "creator_uid": 133,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480399697",
    "length": 33
  },
  {
    "id": 972,
    "uuid": "920e265b-cbc6-4d49-82e8-dd49abb650da",
    "hitokoto": "We're here to put a dent in the universe. Otherwise why else even be here?",
    "type": "g",
    "from": "Steve Jobs",
    "from_who": null,
    "creator": "Secret",
    "creator_uid": 133,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480399740",
    "length": 74
  },
  {
    "id": 975,
    "uuid": "2b2246b6-de54-4e08-b27c-402aa2a29b8a",
    "hitokoto": "不诱于誉，不恐于诽。",
    "type": "g",
    "from": "荀子",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480515167",
    "length": 10
  },
  {
    "id": 1021,
    "uuid": "155fd09a-fccb-4603-81ef-fe0b13726686",
    "hitokoto": "有一天我变老了，不知道你会不会像现在这么照顾我。",
    "type": "g",
    "from": "我与狗狗的十个约定",
    "from_who": "川口晴",
    "creator": "1877035391",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 24
  },
  {
    "id": 1053,
    "uuid": "3a64d103-f679-488f-8ae2-53ec6de011f2",
    "hitokoto": "哈，所谓愿望能靠法宝就实现，也太廉价了吧？",
    "type": "g",
    "from": "仙剑奇侠传五",
    "from_who": "龙幽",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 21
  },
  {
    "id": 1056,
    "uuid": "4d835cb1-6505-4115-8ac7-72d434846d48",
    "hitokoto": "活着的时候要尽欢，死的时候才没有遗憾。",
    "type": "g",
    "from": "仙剑奇侠传四",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 19
  },
  {
    "id": 1072,
    "uuid": "1a11b7b0-5dc6-4c69-b7f2-3fab4622b477",
    "hitokoto": "大丈夫立世无所畏惧。",
    "type": "g",
    "from": "仙剑奇侠传四",
    "from_who": "云天青",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 10
  },
  {
    "id": 1074,
    "uuid": "7bff3ebf-f235-45f1-a221-2ba631e882e5",
    "hitokoto": "苟利国家生死以，岂因祸福避趋之",
    "type": "g",
    "from": "赴戍登程口占示家人",
    "from_who": "林则徐",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 15
  },
  {
    "id": 1075,
    "uuid": "7858b65c-c359-49b5-babe-d20ed0253a5e",
    "hitokoto": "有时候解释是不必要的，敌人不信你的解释，朋友无需你的解释",
    "type": "g",
    "from": "其他",
    "from_who": "李敖",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 28
  },
  {
    "id": 1080,
    "uuid": "a6718f5e-de57-4384-8e41-dd796feb0d6b",
    "hitokoto": "十年饮冰，难凉热血",
    "type": "g",
    "from": "饮冰室文集",
    "from_who": "梁启超",
    "creator": "Hex Lee",
    "creator_uid": 107,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481252569",
    "length": 9
  },
  {
    "id": 1081,
    "uuid": "b39891d0-aac6-4f4b-a0bd-454772caeeb6",
    "hitokoto": "眼睛一闭一睁，这一天就过去了；这眼睛一闭不睁，这辈子就过去了。",
    "type": "g",
    "from": "小沈阳",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481443617",
    "length": 31
  },
  {
    "id": 1082,
    "uuid": "ab89b12e-359b-4cfe-b50d-de35a20bf928",
    "hitokoto": "众里寻他千百度，蓦然回首，那人却在，灯火阑珊处。",
    "type": "g",
    "from": "青玉案·元夕",
    "from_who": null,
    "creator": "131",
    "creator_uid": 146,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481559051",
    "length": 24
  },
  {
    "id": 1083,
    "uuid": "3e7e0768-414e-46ff-856e-fa7b231c16e0",
    "hitokoto": "自由不是你想干什么就干什么，而是你想不干什么就不干什么。",
    "type": "g",
    "from": "康德",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481961053",
    "length": 28
  },
  {
    "id": 1084,
    "uuid": "348ca8b4-ea83-49ea-a6cf-b27db1e22040",
    "hitokoto": "人不是靠做出来的 而是靠活出来的。",
    "type": "g",
    "from": "士兵突击",
    "from_who": null,
    "creator": "哆啦尼可夫",
    "creator_uid": 163,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481965856",
    "length": 17
  },
  {
    "id": 1085,
    "uuid": "745a6696-7c0b-4c80-ba2d-98c42b3e4dc3",
    "hitokoto": "不幸才是生活的常态。",
    "type": "g",
    "from": "法医秦明",
    "from_who": null,
    "creator": "Secret",
    "creator_uid": 133,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1482047360",
    "length": 10
  },
  {
    "id": 1101,
    "uuid": "8556b435-4aa6-49d4-855c-6aba5e4c65fd",
    "hitokoto": "一个人对自己动机的诚实程度，决定着一个人是虚伪还是真诚。",
    "type": "g",
    "from": "我们与这个世界的误会",
    "from_who": "灵山居士",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 28
  },
  {
    "id": 1107,
    "uuid": "2d99adad-0afa-4429-adc2-edf6e9311495",
    "hitokoto": "守住一方平安，尽力而为，问心无愧就好。",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 19
  },
  {
    "id": 1128,
    "uuid": "5a27acd9-57a6-4b01-83af-79f4de7deb03",
    "hitokoto": "湛蓝色的初一，柠檬色的海。",
    "type": "g",
    "from": "TARA组合",
    "from_who": null,
    "creator": "初一",
    "creator_uid": 179,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1483065237",
    "length": 13
  },
  {
    "id": 1134,
    "uuid": "c5e70833-e866-4759-8639-a6874c543c38",
    "hitokoto": "奇迹，只不过是努力的另一个名字罢了。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486034893",
    "length": 18
  },
  {
    "id": 1143,
    "uuid": "bb7accec-2e05-474f-832f-b3e2bf5e692b",
    "hitokoto": "义人的口谈论智慧，他的舌讲说公平",
    "type": "g",
    "from": "圣经",
    "from_who": null,
    "creator": "失われた未来を求めて",
    "creator_uid": 235,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1487085311",
    "length": 16
  },
  {
    "id": 1150,
    "uuid": "579a7e97-907d-4748-b456-eafe5ec71e67",
    "hitokoto": "丁丁漏水夜何长，漫漫轻云露月光。",
    "type": "g",
    "from": "秋夜曲",
    "from_who": null,
    "creator": "zrnlkc",
    "creator_uid": 266,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1489896568",
    "length": 16
  },
  {
    "id": 1169,
    "uuid": "3d15677b-9c75-4bc7-ab22-1e7ce898b5ed",
    "hitokoto": "生活不止眼前的苟且，还应该有诗和远方的田野。",
    "type": "g",
    "from": "生活不止眼前的苟且",
    "from_who": "许巍",
    "creator": "zcq",
    "creator_uid": 297,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491639244",
    "length": 22
  },
  {
    "id": 1178,
    "uuid": "9a77305c-56c7-4b46-b617-e927e3e34f13",
    "hitokoto": "分别后的难过都是依赖，无法相拥的人要好好道别",
    "type": "g",
    "from": "至此流年各天涯",
    "from_who": "我不李志",
    "creator": "少年",
    "creator_uid": 374,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1494076493",
    "length": 22
  },
  {
    "id": 1181,
    "uuid": "2da92e38-7b7d-4d1d-a548-829a09a61dac",
    "hitokoto": "明月楼高休独倚，酒入愁肠，化作相思泪。",
    "type": "g",
    "from": "苏幕遮",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1495198651",
    "length": 19
  },
  {
    "id": 1182,
    "uuid": "d601d731-8d4d-4381-886c-5751c765e3fc",
    "hitokoto": "踏长风破万里浪",
    "type": "g",
    "from": "小C",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1495198575",
    "length": 7
  },
  {
    "id": 1184,
    "uuid": "7a333628-ab7a-48e5-bb97-f34814fcfdf1",
    "hitokoto": "凤兮凤兮归故乡，遨游四海求其凰",
    "type": "g",
    "from": "凤求凰",
    "from_who": null,
    "creator": "yc",
    "creator_uid": 162,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1496649165",
    "length": 15
  },
  {
    "id": 1191,
    "uuid": "b85254d4-e6e7-4a73-8a30-77b9424b626d",
    "hitokoto": "足吾所好，玩而老焉",
    "type": "g",
    "from": "欧阳修",
    "from_who": null,
    "creator": "Hex Lee",
    "creator_uid": 107,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497687720",
    "length": 9
  },
  {
    "id": 1194,
    "uuid": "12d1ec9a-a4e9-4dbf-9d73-255fa00999fa",
    "hitokoto": "善恶终有报，天道好轮回。不信抬头看，苍天饶过谁。",
    "type": "g",
    "from": "江湖夜雨十年灯",
    "from_who": null,
    "creator": "不善",
    "creator_uid": 433,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498006504",
    "length": 24
  },
  {
    "id": 1197,
    "uuid": "383369b9-2d6b-48ef-b20f-99d46a169bf7",
    "hitokoto": "若教眼底无离恨，不信人间有白头",
    "type": "g",
    "from": "鹧鸪天·晚日寒鸦一片愁",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499181701",
    "length": 15
  },
  {
    "id": 1198,
    "uuid": "3d098144-60aa-4941-8f57-6d92ad1aa605",
    "hitokoto": "生而贫穷并无过错,死而贫穷才是遗憾.",
    "type": "g",
    "from": "财箴",
    "from_who": null,
    "creator": "Itsusinn",
    "creator_uid": 444,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498826776",
    "length": 18
  },
  {
    "id": 1209,
    "uuid": "22763b72-ee49-46f9-8416-42491ef9e480",
    "hitokoto": "你要做一个不动声色的大人了，不准情绪化，不准偷偷想念，不准回头看，去过自己另外的生活，你要听话，不是所有的鱼都生活在同一片海里",
    "type": "g",
    "from": "舞舞舞",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499181829",
    "length": 63
  },
  {
    "id": 1218,
    "uuid": "a2cc5157-f532-41c2-af87-d798eef1a227",
    "hitokoto": "年轻时最大的财富，不是你的青春，不是你的美貌，也不是你有充沛的精力，而是你有犯错误的机会。",
    "type": "g",
    "from": "微博",
    "from_who": null,
    "creator": "心随和",
    "creator_uid": 476,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501483309",
    "length": 45
  },
  {
    "id": 1234,
    "uuid": "3405243d-33bc-4029-9bac-bb58732ee6b8",
    "hitokoto": "Across the Great Wall we can reach every corner in the world.",
    "type": "g",
    "from": "中国第一封电子邮件",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502506373",
    "length": 61
  },
  {
    "id": 1241,
    "uuid": "209bd172-7a45-4907-9319-b5380ebf83de",
    "hitokoto": "Let the hacking begin.",
    "type": "g",
    "from": "the social network",
    "from_who": null,
    "creator": "deroubkal",
    "creator_uid": 525,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1504779729",
    "length": 22
  },
  {
    "id": 1259,
    "uuid": "8b87d7fc-ba11-4b13-8ee9-c60d5a976cc9",
    "hitokoto": "千里之行，始于足下。",
    "type": "g",
    "from": "道德经",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507109801",
    "length": 10
  },
  {
    "id": 1260,
    "uuid": "6e8801ff-3af8-446a-a069-660f53ad21fa",
    "hitokoto": "工业革命的火种燃起的那一刻，半个天空的星辰都熄灭了。",
    "type": "g",
    "from": "毛布斯",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507090687",
    "length": 26
  },
  {
    "id": 1261,
    "uuid": "18b45efc-342f-46f5-aac4-f4ea8197c87c",
    "hitokoto": "云销雨霁，彩彻区明。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184953",
    "length": 10
  },
  {
    "id": 1262,
    "uuid": "f9e202a3-22d0-4426-aa39-97bb0a8e9c2c",
    "hitokoto": "落霞与孤鹜齐飞，秋水共长天一色。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184974",
    "length": 16
  },
  {
    "id": 1263,
    "uuid": "a58936ac-f3fb-4e5d-838e-a77a7219d1a4",
    "hitokoto": "渔舟唱晚，响穷彭蠡之滨；雁阵惊寒，声断衡阳之浦。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184994",
    "length": 24
  },
  {
    "id": 1264,
    "uuid": "f24edb67-7408-4a3a-868e-b39690cf4b6b",
    "hitokoto": "关山难越，谁悲失路之人？萍水相逢，尽是他乡之客。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507185043",
    "length": 24
  },
  {
    "id": 1265,
    "uuid": "72455253-d0c9-4ded-8e96-f94a00ce8ecc",
    "hitokoto": "老当益壮，宁移白首之心？穷且益坚，不坠青云之志。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507185409",
    "length": 24
  },
  {
    "id": 1266,
    "uuid": "3b7b75c3-d73a-4369-b9c0-6c8002940bb6",
    "hitokoto": "腾蛟起凤，孟学士之词宗；紫电青霜，王将军之武库。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184728",
    "length": 24
  },
  {
    "id": 1267,
    "uuid": "c0d158d6-db57-4661-8c96-23b7469a02c1",
    "hitokoto": "闾阎扑地，钟鸣鼎食之家；舸舰迷津，青雀黄龙之舳。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184931",
    "length": 24
  },
  {
    "id": 1268,
    "uuid": "6d8ac16c-ef00-438d-b26d-69cae52a3009",
    "hitokoto": "层峦耸翠，上出重霄；飞阁流丹，下临无地。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184845",
    "length": 20
  },
  {
    "id": 1269,
    "uuid": "1339e820-320a-429f-8de5-193d646571a7",
    "hitokoto": "不知横跨几度银河，才终于在尽头与你相遇",
    "type": "g",
    "from": "前前前世",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184566",
    "length": 19
  },
  {
    "id": 1270,
    "uuid": "fca341b2-cd98-49c7-bccf-b748ac93f369",
    "hitokoto": "鹤汀凫渚，穷岛屿之萦回；桂殿兰宫，即冈峦之体势。",
    "type": "g",
    "from": "滕王阁序",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507184887",
    "length": 24
  },
  {
    "id": 1273,
    "uuid": "35cb324d-5304-4c92-87a4-2b06075753d5",
    "hitokoto": "该庆幸至远至疏你我还未至陌路",
    "type": "g",
    "from": "眉间雪",
    "from_who": null,
    "creator": "無痕",
    "creator_uid": 607,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508773100",
    "length": 14
  },
  {
    "id": 1276,
    "uuid": "ee4ba85b-7af3-4d8f-990c-bb3f53c7b624",
    "hitokoto": "得到了再失去，总是比从来就没有得到更伤人。",
    "type": "g",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508659584",
    "length": 21
  },
  {
    "id": 1277,
    "uuid": "2cfe191f-941f-48bd-89c5-9dbeb3c81373",
    "hitokoto": "时间很贪婪——有时候，它会独自吞噬所有的细节。",
    "type": "g",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508659562",
    "length": 23
  },
  {
    "id": 1278,
    "uuid": "34c9134d-b543-4f23-bf5e-029825cf4a6d",
    "hitokoto": "为你，千千万万遍。",
    "type": "g",
    "from": "追风筝的人",
    "from_who": null,
    "creator": "毛毛毛布斯",
    "creator_uid": 562,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508659520",
    "length": 9
  },
  {
    "id": 1289,
    "uuid": "c269f6b9-0748-433b-833c-642e9778b92c",
    "hitokoto": "纯氧对生物有害，毫无保留的真相，只会把人的精神击溃。一比五的氧与氮，才是可供呼吸的空气。同样，呼吸着以戏言稀释的少量真实，人才能维持健全的心。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "Mysaku",
    "creator_uid": 627,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509445881",
    "length": 71
  },
  {
    "id": 1291,
    "uuid": "9f6c1eaf-c165-4980-b257-8e114ccefe84",
    "hitokoto": "相逢尽道休官好，林下何曾见一人。",
    "type": "g",
    "from": "东林寺酬韦丹刺史",
    "from_who": null,
    "creator": "LegendHeaven",
    "creator_uid": 688,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509707593",
    "length": 16
  },
  {
    "id": 1296,
    "uuid": "567c15bd-d766-44eb-b419-a1a2887ac03b",
    "hitokoto": "不忘初心，努力前行",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "flyqie",
    "creator_uid": 577,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1510457164",
    "length": 9
  },
  {
    "id": 1301,
    "uuid": "08191a75-06a9-47d0-8471-b0e2c6a2105d",
    "hitokoto": "你说一声，我也默认，我们在这月光下十指生根。",
    "type": "g",
    "from": "芬芳一生",
    "from_who": "毛不易",
    "creator": "不负",
    "creator_uid": 818,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1511872520",
    "length": 22
  },
  {
    "id": 1314,
    "uuid": "481f8a1e-b7ce-44dd-9dd4-2ceb150777f2",
    "hitokoto": "不知寒暑，不识香臭，不辨是非，无家国之念，无亲情之观，无喜乐，无悲欢，与朽木何异？",
    "type": "g",
    "from": "别听他胡说",
    "from_who": null,
    "creator": "宝宝洗头爱飘柔",
    "creator_uid": 898,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512718046",
    "length": 41
  },
  {
    "id": 1332,
    "uuid": "7e4c17fc-6c5c-40fd-b64f-2efd34bd9002",
    "hitokoto": "贫贱难可居，脱误有功，富贵可致，不探虎穴，安得虎子？",
    "type": "g",
    "from": "三国志",
    "from_who": null,
    "creator": "LegendHeaven",
    "creator_uid": 688,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513446675",
    "length": 26
  },
  {
    "id": 1337,
    "uuid": "2008003e-4ed5-444a-8633-9dae01a8c12f",
    "hitokoto": "你要不会唠嗑能不能别硬唠。",
    "type": "g",
    "from": "缝纫机乐队",
    "from_who": null,
    "creator": "十七",
    "creator_uid": 983,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514253620",
    "length": 13
  },
  {
    "id": 1342,
    "uuid": "bdba2cf7-d5c8-44ec-bdec-f7c8c09fd5c8",
    "hitokoto": "故人啊 已做了他人嫁",
    "type": "g",
    "from": "一醉南柯",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514702738",
    "length": 10
  },
  {
    "id": 1344,
    "uuid": "5779e723-90a2-4f40-a408-adbf8368d4f6",
    "hitokoto": "看春花开又落,秋风吹着那夏月走,冬雪纷纷又是一年",
    "type": "g",
    "from": "如花",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514706821",
    "length": 24
  },
  {
    "id": 1348,
    "uuid": "81e44d44-a1b2-41a2-8206-7c3676a63660",
    "hitokoto": "此心光明，亦复何言",
    "type": "g",
    "from": "王阳明",
    "from_who": null,
    "creator": "你猜啊",
    "creator_uid": 1019,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515119154",
    "length": 9
  },
  {
    "id": 1354,
    "uuid": "672da631-57a5-4b04-88d2-921e1a9a694a",
    "hitokoto": "于是荆轲遂就车而去，终已不顾。",
    "type": "g",
    "from": "史记·刺客列传",
    "from_who": null,
    "creator": "死木芽",
    "creator_uid": 1033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515592586",
    "length": 15
  },
  {
    "id": 1362,
    "uuid": "15d99732-1528-4fe4-84c6-f6800fed87b7",
    "hitokoto": "不管是哪种结果，我都坦然接受。因为无论是哪种结果，这都是一次非凡的旅行。",
    "type": "g",
    "from": "地心引力",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516498266",
    "length": 36
  },
  {
    "id": 1367,
    "uuid": "f069b1c1-306e-4865-b471-28515dc81cbe",
    "hitokoto": "Dream big and dare to fail.勇敢追梦、无惧失败。",
    "type": "g",
    "from": "Norman Vaughan",
    "from_who": null,
    "creator": "liufushihai",
    "creator_uid": 1089,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516862700",
    "length": 37
  },
  {
    "id": 1379,
    "uuid": "95f5e070-1df4-44ce-b516-ffb620ed903d",
    "hitokoto": "万有引力可无法对坠入爱河的人负责。",
    "type": "g",
    "from": "爱因斯坦",
    "from_who": null,
    "creator": "Mockaven",
    "creator_uid": 701,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519392032",
    "length": 17
  },
  {
    "id": 1381,
    "uuid": "1e814fd3-e14d-468c-a47a-b357332ce187",
    "hitokoto": "人这辈子没法做太多事情，所以每一件都要做到精彩绝伦。",
    "type": "g",
    "from": "乔布斯",
    "from_who": null,
    "creator": "nanokya",
    "creator_uid": 1210,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519635181",
    "length": 26
  },
  {
    "id": 1391,
    "uuid": "f088e9b9-5f63-4592-846b-91c7b625bc6f",
    "hitokoto": "爱的是你，最爱的还是你。",
    "type": "g",
    "from": "日常",
    "from_who": null,
    "creator": "christ@amaok.com",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1428035779000",
    "length": 12
  },
  {
    "id": 1397,
    "uuid": "9d8a3fe2-2bc9-4d72-b5a5-58c6fff710a8",
    "hitokoto": "螃蟹在剥我的壳，笔记本在写我。漫天的我落在枫叶上雪花上。而你在想我。",
    "type": "g",
    "from": "三句情诗",
    "from_who": null,
    "creator": "pw0",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1460208005000",
    "length": 34
  },
  {
    "id": 3585,
    "uuid": "1cc9ce51-824f-4198-bb35-dede61287bed",
    "hitokoto": "我永远在这里，涌着爱面朝沧海",
    "type": "g",
    "from": "第三极",
    "from_who": null,
    "creator": "泷涯",
    "creator_uid": 1291,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521366906",
    "length": 14
  },
  {
    "id": 3591,
    "uuid": "4fcbbd6d-8034-4eaa-9062-63af8e6a3524",
    "hitokoto": "那天她夸我很会笑,那十秒灵魂大概已卖掉.",
    "type": "g",
    "from": "Nice · 南先生",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521812182",
    "length": 20
  },
  {
    "id": 3597,
    "uuid": "f04c9f06-415f-4922-8fa8-a7ddac65fc8d",
    "hitokoto": "一辈子那么长，我才不会只喜欢你一个人。",
    "type": "g",
    "from": "至我们单纯的小美好",
    "from_who": null,
    "creator": "alone88",
    "creator_uid": 1373,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523531645",
    "length": 19
  },
  {
    "id": 3608,
    "uuid": "72d97fe3-29d4-482d-b297-bc9416217c6a",
    "hitokoto": "无能为力的同情比欺负本身更伤人。",
    "type": "g",
    "from": "终极恶女",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579662",
    "length": 16
  },
  {
    "id": 3609,
    "uuid": "665fe28e-c031-47ff-a3d9-1ce3e8076c3e",
    "hitokoto": "菩提本无树，明镜亦非台，本来无一物，何处惹尘埃。",
    "type": "g",
    "from": "慧能",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523580061",
    "length": 24
  },
  {
    "id": 3610,
    "uuid": "efab198b-099d-4721-809c-2a42423af01d",
    "hitokoto": "身是菩提树，心如明镜台，时时勤拂拭，勿使惹尘埃。",
    "type": "g",
    "from": "神秀",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523580040",
    "length": 24
  },
  {
    "id": 3611,
    "uuid": "75ee1579-ea53-4efb-994f-0e3ec6dfe69a",
    "hitokoto": "一个人至少拥有一个梦想，有一个理由去坚强。心若没有栖息的地方，到哪里都是在流浪。",
    "type": "g",
    "from": "三毛",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579910",
    "length": 40
  },
  {
    "id": 3612,
    "uuid": "892f50b7-a5e1-4bce-aa52-13325872dc42",
    "hitokoto": "如果有来生，要做一棵树，站成永恒，没有悲欢的姿势。一半在土里安详，一半在风里飞扬，一半洒落阴凉，一半沐浴阳光，非常沉默非常骄傲，从不依靠 从不寻找。",
    "type": "g",
    "from": "说给自己听",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579872",
    "length": 74
  },
  {
    "id": 3628,
    "uuid": "171c3afc-8694-4a6c-92e6-1560c365e53b",
    "hitokoto": "千般荒凉，以此为梦；万里蹀躞，以此为归。",
    "type": "g",
    "from": "文化苦旅",
    "from_who": null,
    "creator": "yyy2015c01",
    "creator_uid": 1454,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1525442422",
    "length": 20
  },
  {
    "id": 3629,
    "uuid": "516bccf0-3e55-44d9-a68a-b6719a2a3122",
    "hitokoto": "愿您的每句评论，都能给大家的生活添色彩，带来共鸣，带来思索，带来快乐。",
    "type": "g",
    "from": "酷软资源网",
    "from_who": null,
    "creator": "sverain",
    "creator_uid": 1487,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1525924469",
    "length": 35
  },
  {
    "id": 3638,
    "uuid": "658a50b6-5bfe-4c61-8955-6e8278a6261f",
    "hitokoto": "三更灯火五更鸡，正是男儿读书时。黑发不知勤学早，白首方悔读书迟。",
    "type": "g",
    "from": "颜真卿",
    "from_who": null,
    "creator": "lohmo",
    "creator_uid": 1451,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527173307",
    "length": 32
  },
  {
    "id": 3642,
    "uuid": "8f31c1b5-c84f-4637-b497-d9a478497823",
    "hitokoto": "gugugugugu",
    "type": "g",
    "from": "haoduor",
    "from_who": null,
    "creator": "haoduor",
    "creator_uid": 1545,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527736452",
    "length": 10
  },
  {
    "id": 3643,
    "uuid": "89d9be9e-fba9-4c4e-b8c5-f9b8ee185ff7",
    "hitokoto": "纵有疾风起人生不言弃",
    "type": "g",
    "from": "宫崎骏",
    "from_who": null,
    "creator": "woober",
    "creator_uid": 1568,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527740056",
    "length": 10
  },
  {
    "id": 3644,
    "uuid": "93566676-977f-485d-8f43-c95ec6c8c483",
    "hitokoto": "只要有人追忆，往事就不必如烟。",
    "type": "g",
    "from": "史景迁",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527784680",
    "length": 15
  },
  {
    "id": 3645,
    "uuid": "a72dabd1-7754-47ac-8c18-c80b2e05b214",
    "hitokoto": "人是一个事件，它无法判断自己，是好是坏，全都交由他人评判",
    "type": "g",
    "from": "荣格自传",
    "from_who": null,
    "creator": "kujin",
    "creator_uid": 1577,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527901264",
    "length": 28
  },
  {
    "id": 3654,
    "uuid": "8e204205-cde2-4669-b5e9-0bb53ecaed64",
    "hitokoto": "在这样一个世界里，生活的真实性被所谓的清晰概念完全掩盖。经验的本质被剥夺殆尽，取而代之的却只是空有的名称，而这些名称进而有取代了现实。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "kujin",
    "creator_uid": 1577,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528212772",
    "length": 67
  },
  {
    "id": 3671,
    "uuid": "be43a666-0e2f-4aa3-af40-8c8474fa892e",
    "hitokoto": "信息学竞赛中没有证明。",
    "type": "g",
    "from": "wxh010910",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528593998",
    "length": 11
  },
  {
    "id": 3698,
    "uuid": "ee963570-f858-4097-b343-503a3f2e4708",
    "hitokoto": "知我者谓我心忧",
    "type": "g",
    "from": "佚名.",
    "from_who": null,
    "creator": "wyt",
    "creator_uid": 1735,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530635694",
    "length": 7
  },
  {
    "id": 3707,
    "uuid": "caf3b338-b8ce-4471-b180-37dbb6bfbc91",
    "hitokoto": "我从没有爱过这世界，它对我也一样",
    "type": "g",
    "from": "拜伦诗集",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015246",
    "length": 16
  },
  {
    "id": 3711,
    "uuid": "ea588c4b-1cd8-400b-9350-db27d0e3e2e1",
    "hitokoto": "饭可以一日不吃，水可以一日不喝，但题不可以一日不贺",
    "type": "g",
    "from": "贺指导",
    "from_who": null,
    "creator": "mangoyang",
    "creator_uid": 1851,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532860764",
    "length": 25
  },
  {
    "id": 3714,
    "uuid": "d8d98707-18d8-4867-9249-c379cf73d4ec",
    "hitokoto": "别紧张，我又不是什么好人。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854331",
    "length": 13
  },
  {
    "id": 3715,
    "uuid": "bfc06e2b-7220-4c43-b98c-05696910209a",
    "hitokoto": "最近总是失眠16个小时就会醒一次。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854345",
    "length": 17
  },
  {
    "id": 3716,
    "uuid": "6798e7b5-9f68-4124-a743-513339a0fdcb",
    "hitokoto": "在哪里摔倒就在那里躺着",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854354",
    "length": 11
  },
  {
    "id": 3717,
    "uuid": "f7895ac6-f281-4c8d-870c-514515ffe947",
    "hitokoto": "知道你过得不好我也就安心了。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854384",
    "length": 14
  },
  {
    "id": 3718,
    "uuid": "fda2eb86-5072-41dc-ac25-6a322cb6560e",
    "hitokoto": "通往成功的路，总是在施工中。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854319",
    "length": 14
  },
  {
    "id": 3719,
    "uuid": "0d1e48fe-873e-4cc3-9b18-53558732b759",
    "hitokoto": "兜里不硬气，啥都不敢买。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854271",
    "length": 12
  },
  {
    "id": 3749,
    "uuid": "b8b1c8e6-c6bb-49c7-b10c-172e11f43b02",
    "hitokoto": "永远相信美好的事情即将发生",
    "type": "g",
    "from": "小米",
    "from_who": null,
    "creator": "老陈皮",
    "creator_uid": 1920,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534278086",
    "length": 13
  },
  {
    "id": 3762,
    "uuid": "3f8accd4-b33b-44a7-b395-7998d3c21a49",
    "hitokoto": "昔日我曾苍老，如今风华正茂",
    "type": "g",
    "from": "鲍勃·迪伦",
    "from_who": null,
    "creator": "etppt",
    "creator_uid": 1863,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534374940",
    "length": 13
  },
  {
    "id": 3771,
    "uuid": "299fb107-b113-41c1-b438-ca99546f65ad",
    "hitokoto": "气势上不能怂！",
    "type": "g",
    "from": "tea9",
    "from_who": null,
    "creator": "tea9",
    "creator_uid": 1901,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533803645",
    "length": 7
  },
  {
    "id": 3774,
    "uuid": "72b128d0-a84c-4ded-9b4b-92d0025f16f9",
    "hitokoto": "世上无难事，只要肯放弃。",
    "type": "g",
    "from": "嘉豪and佳一",
    "from_who": null,
    "creator": "36778038",
    "creator_uid": 1849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854307",
    "length": 12
  },
  {
    "id": 3790,
    "uuid": "ffdb670d-e567-4405-9590-981289cb20e6",
    "hitokoto": "时间背着我悄悄捏碎从前",
    "type": "g",
    "from": "消失",
    "from_who": null,
    "creator": "shikisuki",
    "creator_uid": 1852,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533353534",
    "length": 11
  },
  {
    "id": 3796,
    "uuid": "d970ea61-f10f-4ea5-8cfa-7f5e11735a5f",
    "hitokoto": "我对你最深沉的爱，莫过于分开以后，我将自己活成了你的样子。直到今天，再听到你的消息，为你活得越来越精彩而万分开心，虽然在离开你之后，我彻底变成了灰色。",
    "type": "g",
    "from": "这个杀手不太冷",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106811",
    "length": 75
  },
  {
    "id": 3808,
    "uuid": "d1cfff58-2370-487a-9c72-3f8eef2eefdd",
    "hitokoto": "我认为最深沉的爱；莫过于你离开以后；我活成了你的样子。",
    "type": "g",
    "from": "这个杀手不太冷",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106839",
    "length": 27
  },
  {
    "id": 3817,
    "uuid": "30db0dbc-602d-4136-8cd8-9167d15eafe5",
    "hitokoto": "远远地看，它就像一根孤独的琴弦紧绷在原野上，任凭风雨和岁月的弹拨。",
    "type": "g",
    "from": "那条河流",
    "from_who": null,
    "creator": "少年听雨歌楼上",
    "creator_uid": 1950,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534941861",
    "length": 33
  },
  {
    "id": 3837,
    "uuid": "73f4d253-b7cd-44df-ace3-c76567e58f9e",
    "hitokoto": "但尽人事，莫问前程。",
    "type": "g",
    "from": "名人",
    "from_who": null,
    "creator": "microtex",
    "creator_uid": 2044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536488027",
    "length": 10
  },
  {
    "id": 3860,
    "uuid": "f4831655-fb2e-4531-ae4f-1739e8df767b",
    "hitokoto": "程序员最讨厌的事情是维护没有注释的代码，第二讨厌的的事情是自己写注释。",
    "type": "g",
    "from": "biguokang",
    "from_who": null,
    "creator": "biguokang",
    "creator_uid": 1829,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532657350",
    "length": 35
  },
  {
    "id": 3869,
    "uuid": "9dd1d9f5-15f7-4a71-a3f0-b99dbed623b4",
    "hitokoto": "戸惑い憂い怒り狂い たどり着いた祈り 君の心死なずいるなら 応答せよ早急に",
    "type": "g",
    "from": "miku",
    "from_who": null,
    "creator": "mohei0",
    "creator_uid": 2003,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535713061",
    "length": 37
  },
  {
    "id": 3930,
    "uuid": "420f0a31-21d3-4aba-ba62-934c93cb120f",
    "hitokoto": "故事开始便不承认普通",
    "type": "g",
    "from": "君子剑伤",
    "from_who": null,
    "creator": "千微浅",
    "creator_uid": 2108,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538112271",
    "length": 10
  },
  {
    "id": 3933,
    "uuid": "ee5e1f3d-8525-4f50-a0f5-f3c640e53dca",
    "hitokoto": "不要熄灭你的灵感及想象，不要成为你楷模的奴隶。",
    "type": "g",
    "from": "文森特·梵高",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538390679",
    "length": 23
  },
  {
    "id": 3942,
    "uuid": "539b3cee-4526-411b-9d59-b303cf823745",
    "hitokoto": "该打的仗我已经打过了，该走的路已经走到了尽头，我守住了我信的道。",
    "type": "g",
    "from": "动物世界",
    "from_who": null,
    "creator": "Encounter",
    "creator_uid": 2142,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538709772",
    "length": 32
  },
  {
    "id": 3945,
    "uuid": "0b489d7f-482f-49ad-82b5-00328691bb1a",
    "hitokoto": "沸乳看蟹目鱼鳞，传瓷选月魂云魄。",
    "type": "g",
    "from": "影梅庵忆语",
    "from_who": null,
    "creator": "xinli",
    "creator_uid": 2060,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536914534",
    "length": 16
  },
  {
    "id": 3947,
    "uuid": "50bbf09c-da84-4129-acff-8426a2ee938b",
    "hitokoto": "有一个夜晚我烧毁了所有的记忆，从此我的梦就透明了；有一个早晨我扔掉了所有的昨天，从此我的脚步就轻盈了。",
    "type": "g",
    "from": "泰戈尔",
    "from_who": null,
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538802056",
    "length": 51
  },
  {
    "id": 3954,
    "uuid": "748acfaf-a644-4866-b96f-71fc9f7a30b0",
    "hitokoto": "满天都是星星，好像一场冻结了的大雨。",
    "type": "g",
    "from": "王小波",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539487708",
    "length": 18
  },
  {
    "id": 3959,
    "uuid": "be47a27d-6ef9-4418-8e97-da0c43ad22d8",
    "hitokoto": "梦与现实是不同的。所以才能够为了把梦变成现实而努力。",
    "type": "g",
    "from": "梦违科学世纪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687759",
    "length": 26
  },
  {
    "id": 3960,
    "uuid": "6e4f4d76-3405-476c-8f39-9f4cfc8cb39b",
    "hitokoto": "奇变偶不变，符号看象限",
    "type": "g",
    "from": "各校数学老师",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539689012",
    "length": 11
  },
  {
    "id": 3965,
    "uuid": "3ac5dec2-584b-401c-919d-eef9ea3e6a20",
    "hitokoto": "你的笑像一条恶犬，撞乱了我心弦",
    "type": "g",
    "from": "盗将行",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541653181",
    "length": 15
  },
  {
    "id": 3969,
    "uuid": "95863f0b-83a1-46e8-9c41-bbdbc4f4bb7b",
    "hitokoto": "自古美人如名将，不许人间见白头",
    "type": "g",
    "from": "随园诗话",
    "from_who": null,
    "creator": "双语之城",
    "creator_uid": 2271,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540972035",
    "length": 15
  },
  {
    "id": 3983,
    "uuid": "123677df-404d-4170-b24e-45d79777d286",
    "hitokoto": "可以看起来不伟大却要善良，要尝过时间给过的挫败才能够变得坦然。",
    "type": "g",
    "from": "李荣浩",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540721786",
    "length": 31
  },
  {
    "id": 3991,
    "uuid": "4d1481e5-b65e-4948-8eaa-e961a78f734b",
    "hitokoto": "眼看他起朱楼，眼看他宴宾客，眼看他楼塌了。",
    "type": "g",
    "from": "桃花扇",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539688046",
    "length": 21
  },
  {
    "id": 3992,
    "uuid": "02d89ef9-3ddd-4584-aff2-1eafcd8c95b4",
    "hitokoto": "空无一物本身，是一些无惧无畏的旅人的起点，却是我的终点。",
    "type": "g",
    "from": "老巴塔哥尼亚快车",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539688394",
    "length": 28
  },
  {
    "id": 3994,
    "uuid": "8a929308-167e-4478-90e1-76a2315d38ad",
    "hitokoto": "只有不怕死的人才配活着。",
    "type": "g",
    "from": "麦克阿瑟",
    "from_who": null,
    "creator": "qnickx",
    "creator_uid": 2209,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539852227",
    "length": 12
  },
  {
    "id": 4030,
    "uuid": "cf81ea26-c311-49e6-8bf2-6f1762056922",
    "hitokoto": "春之风，自下升上，纸鸢因之以起。夏之风，横行空中，故树杪多风声。秋之风，自上而下，木叶因之以陨。冬之风，著土而行，是以吼地而生寒。 ",
    "type": "g",
    "from": "夜航船",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687494",
    "length": 66
  },
  {
    "id": 4032,
    "uuid": "f9715752-45a7-475a-9bf9-48e2e09d1456",
    "hitokoto": "焉得谖草？言树之背。",
    "type": "g",
    "from": "伯兮-先秦",
    "from_who": null,
    "creator": "燕长风",
    "creator_uid": 2190,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539561850",
    "length": 10
  },
  {
    "id": 4036,
    "uuid": "ad04f321-3dd4-4c05-b61b-aa31cd0c7c1e",
    "hitokoto": "你的故事很长，如果能由我来收尾就好了。",
    "type": "g",
    "from": "乱世流年",
    "from_who": null,
    "creator": "乱世流年",
    "creator_uid": 2306,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541909035",
    "length": 19
  },
  {
    "id": 4043,
    "uuid": "5cb76b16-c75a-4091-9d28-c385f2423fae",
    "hitokoto": "浮天水送无穷树，带雨云埋一半山。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561247",
    "length": 16
  },
  {
    "id": 4044,
    "uuid": "92c2ef71-3ada-4af4-8515-4a6f973b2a59",
    "hitokoto": "相信爱的人，才会和爱相遇",
    "type": "g",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542531780",
    "length": 12
  },
  {
    "id": 4045,
    "uuid": "c50114d9-9981-4651-a73f-65639f6721a9",
    "hitokoto": "牛肉面算是我的人生菜单，很高兴有一天，我终于学会了你的味道。",
    "type": "g",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542531641",
    "length": 30
  },
  {
    "id": 4046,
    "uuid": "166a8072-23f7-43e0-bf1c-718fc088d088",
    "hitokoto": "我这一生都是坚定不移的唯物主义者，唯有你，我希望有来生。",
    "type": "g",
    "from": "周恩来",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542463485",
    "length": 28
  },
  {
    "id": 4055,
    "uuid": "9deee378-e537-47e8-9d43-88cc3172a594",
    "hitokoto": "突然觉得人生正面得不行，彻底变成大人了。",
    "type": "g",
    "from": "林宥嘉",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542172061",
    "length": 20
  },
  {
    "id": 4065,
    "uuid": "094934a7-0ec9-4031-9446-b416828c341d",
    "hitokoto": "看过太多的人生指南，都快找不着北了",
    "type": "g",
    "from": "辛巴狗",
    "from_who": null,
    "creator": "一言小和尚",
    "creator_uid": 2393,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544659867",
    "length": 17
  },
  {
    "id": 4066,
    "uuid": "b9fbe3d7-7135-430e-b0c5-440d5a308d85",
    "hitokoto": "漫天星光沿途散播，长路尽处有灯火。",
    "type": "g",
    "from": "最难唱的情歌",
    "from_who": null,
    "creator": "正弦",
    "creator_uid": 2468,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544527066",
    "length": 17
  },
  {
    "id": 4072,
    "uuid": "cfd9489d-3b6e-4443-9f2a-978a73bd5d09",
    "hitokoto": "相逢开口笑，过后不思量。",
    "type": "g",
    "from": "沙家浜",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542850044",
    "length": 12
  },
  {
    "id": 4074,
    "uuid": "e7d9a40b-4a2e-4a97-bf9d-43a2875ec7ae",
    "hitokoto": "透过你的眼，离别也是诗",
    "type": "g",
    "from": "书籍",
    "from_who": null,
    "creator": "aegean",
    "creator_uid": 2394,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543226431",
    "length": 11
  },
  {
    "id": 4075,
    "uuid": "e61d3f5d-a1e2-4cc1-b00a-f478baa7accd",
    "hitokoto": "眼见他起高楼,眼见他宴宾客,眼见他楼塌了!",
    "type": "g",
    "from": "桃花扇",
    "from_who": null,
    "creator": "hytzongxuan",
    "creator_uid": 2319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543234163",
    "length": 21
  },
  {
    "id": 4083,
    "uuid": "df1b7517-0ac8-4431-afa4-68a2206c8e5c",
    "hitokoto": "凡是属于幻觉的东西，过了第一座铁路桥便会消失；凡是实现不了的事物，都会在桦木十字架下被忘记。",
    "type": "g",
    "from": "莫斯科",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687255",
    "length": 46
  },
  {
    "id": 4084,
    "uuid": "0c5386ce-118f-4540-ae7a-d5501c58d63b",
    "hitokoto": "是幻想吗，是空中楼阁吗；在黎明前，这场梦，蝴蝶之梦。",
    "type": "g",
    "from": "梦违科学世纪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687720",
    "length": 26
  },
  {
    "id": 4085,
    "uuid": "e97a577e-6d8f-4ae0-adf0-873f5cb2dc53",
    "hitokoto": "未期之遇，不告而别。闻所闻而来，见所见即去。",
    "type": "g",
    "from": "老巴塔哥尼亚快车",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539687943",
    "length": 22
  },
  {
    "id": 4086,
    "uuid": "4b18471e-b3a2-43f5-afe8-609f17126859",
    "hitokoto": "他不是一个人在战斗！",
    "type": "g",
    "from": "黄健翔",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539689640",
    "length": 10
  },
  {
    "id": 4097,
    "uuid": "0279d1e5-c320-46e7-aa45-e24fc4b7a978",
    "hitokoto": "靠水晶球谋生的人注定要吃碎在地上的玻璃。",
    "type": "g",
    "from": "瑞·达利欧",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538908707",
    "length": 20
  },
  {
    "id": 4123,
    "uuid": "dccf03db-9538-4608-b1ab-dc3c4743c285",
    "hitokoto": "好男儿胸怀像大海",
    "type": "g",
    "from": "曾经的你",
    "from_who": null,
    "creator": "Nihility",
    "creator_uid": 2330,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542188832",
    "length": 8
  },
  {
    "id": 4130,
    "uuid": "1470491e-dc45-4fd3-ae4b-791bad1f6ee4",
    "hitokoto": "霸者之作，其论博也",
    "type": "g",
    "from": "六韬",
    "from_who": null,
    "creator": "二十一",
    "creator_uid": 2361,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542693057",
    "length": 9
  },
  {
    "id": 4137,
    "uuid": "10416d05-eece-4a5b-8bb7-c299413f4a15",
    "hitokoto": "即便如此我也会前进的，哪怕是这令人头昏眼花的夜",
    "type": "g",
    "from": "ゴーストルール",
    "from_who": null,
    "creator": "茅台酒",
    "creator_uid": 2387,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543196186",
    "length": 23
  },
  {
    "id": 4138,
    "uuid": "ea347786-b721-43af-ac30-5689888a9588",
    "hitokoto": "从来不需要想起，永远也不会忘记",
    "type": "g",
    "from": "酒干倘卖无",
    "from_who": null,
    "creator": "aegean",
    "creator_uid": 2394,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543226360",
    "length": 15
  },
  {
    "id": 4140,
    "uuid": "2491e1a8-54f0-453b-af23-d97d6e09ec65",
    "hitokoto": "原谅他是上帝的事情。我的事情就是送他去见上帝",
    "type": "g",
    "from": "爱情公寓",
    "from_who": null,
    "creator": "一言小和尚",
    "creator_uid": 2393,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543289350",
    "length": 22
  },
  {
    "id": 4149,
    "uuid": "b86f2b00-cf18-4b1e-a4aa-7c94807d73e5",
    "hitokoto": "The devil is in the detail. 细节决定成败。",
    "type": "g",
    "from": "谚语",
    "from_who": null,
    "creator": "KanM0DEL",
    "creator_uid": 2428,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543799889",
    "length": 35
  },
  {
    "id": 4152,
    "uuid": "2d45b94e-8790-4324-933f-4cbe69e0143a",
    "hitokoto": "Young as the morning, Old as the sea.",
    "type": "g",
    "from": "Other",
    "from_who": null,
    "creator": "nightkeeper",
    "creator_uid": 2454,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544287597",
    "length": 37
  },
  {
    "id": 4162,
    "uuid": "7d9792a0-76f5-491e-974a-93c7a603554e",
    "hitokoto": "给我这个世界上最诚实的人写的六行字，我一定能从中找到足够的理由来绞死他。",
    "type": "g",
    "from": "黎塞留",
    "from_who": null,
    "creator": "chenxuhua",
    "creator_uid": 2497,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545017593",
    "length": 36
  },
  {
    "id": 4164,
    "uuid": "470e0a50-a810-4a28-9eab-cae889fde459",
    "hitokoto": "致梦想创造游戏的你，请绝对不要让这份情感在梦里终结。",
    "type": "g",
    "from": "三辻富贵朗",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545055043",
    "length": 26
  },
  {
    "id": 4165,
    "uuid": "27bbf648-304d-486d-8d16-8498f1a55f33",
    "hitokoto": "希望是美好的，也许是人间至善，而美好的事物永不消逝。",
    "type": "g",
    "from": "肖申克的救赎",
    "from_who": null,
    "creator": "影探",
    "creator_uid": 2504,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545110701",
    "length": 26
  },
  {
    "id": 4200,
    "uuid": "9033b56c-44c3-4a50-a466-828f3dc41d9a",
    "hitokoto": "日出而作，日入而息。",
    "type": "g",
    "from": "击壤歌",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974068",
    "length": 10
  },
  {
    "id": 4201,
    "uuid": "47629280-cb53-4857-8843-bc07b4804793",
    "hitokoto": "凿井而饮，耕田而食。",
    "type": "g",
    "from": "击壤歌",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974079",
    "length": 10
  },
  {
    "id": 4202,
    "uuid": "4a904723-5e3b-44ab-abd3-a98b2fd6f4b6",
    "hitokoto": "关关雎鸠，在河之洲。窈窕淑女，君子好逑。",
    "type": "g",
    "from": "关雎",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974143",
    "length": 20
  },
  {
    "id": 4203,
    "uuid": "b67a5224-0bce-4cf7-9cea-a7d0f922847e",
    "hitokoto": "参差荇菜，左右流之。窈窕淑女，寤寐求之。",
    "type": "g",
    "from": "关雎",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974151",
    "length": 20
  },
  {
    "id": 4204,
    "uuid": "f9c7cb58-e603-4d53-a6c9-2378f0265e3a",
    "hitokoto": "求之不得，寤寐思服。悠哉悠哉，辗转反侧。",
    "type": "g",
    "from": "关雎",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974162",
    "length": 20
  },
  {
    "id": 4205,
    "uuid": "20deb116-4bed-48f4-9092-124ba6b83cd2",
    "hitokoto": "参差荇菜，左右采之。窈窕淑女，琴瑟友之。",
    "type": "g",
    "from": "关雎",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974173",
    "length": 20
  },
  {
    "id": 4206,
    "uuid": "1e0734a1-4869-489b-afd2-d9483cd0806f",
    "hitokoto": "参差荇菜，左右芼之。窈窕淑女，钟鼓乐之。",
    "type": "g",
    "from": "关雎",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974184",
    "length": 20
  },
  {
    "id": 4207,
    "uuid": "7b5b7403-3cbb-4231-9c4a-879694ab5029",
    "hitokoto": "投我以木瓜，报之以琼琚。匪报也，永以为好也！",
    "type": "g",
    "from": "木瓜",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974198",
    "length": 22
  },
  {
    "id": 4208,
    "uuid": "d1e9f6f0-3bb0-4262-8bb6-c2d033b1110c",
    "hitokoto": "桃之夭夭，灼灼其华。之子于归，宜其室家。",
    "type": "g",
    "from": "桃夭",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974262",
    "length": 20
  },
  {
    "id": 4209,
    "uuid": "023ecedd-4fcf-4c63-a92a-368fe04ad7df",
    "hitokoto": "桃之夭夭，其叶蓁蓁。之子于归，宜其家人。",
    "type": "g",
    "from": "桃夭",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974294",
    "length": 20
  },
  {
    "id": 4210,
    "uuid": "db725ede-c28a-4969-a92c-cd821a6cb695",
    "hitokoto": "蒹葭苍苍，白露为霜。所谓伊人，在水一方。",
    "type": "g",
    "from": "蒹葭",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974339",
    "length": 20
  },
  {
    "id": 4211,
    "uuid": "8cc15097-bc67-468a-aa38-268708fc4976",
    "hitokoto": "蒹葭萋萋，白露未晞。所谓伊人，在水之湄。",
    "type": "g",
    "from": "蒹葭",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974350",
    "length": 20
  },
  {
    "id": 4212,
    "uuid": "1ee16411-2d24-4c0e-b6f0-58e952159d3f",
    "hitokoto": "蒹葭采采，白露未已。所谓伊人，在水之涘。",
    "type": "g",
    "from": "蒹葭",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545974361",
    "length": 20
  },
  {
    "id": 4227,
    "uuid": "886516ee-80c0-494c-bf88-81a8e3e6b3dc",
    "hitokoto": "人活着，当哭则哭，声音不悲不哭。",
    "type": "g",
    "from": "人生",
    "from_who": null,
    "creator": "卡夫卡",
    "creator_uid": 2605,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546698250",
    "length": 16
  },
  {
    "id": 4230,
    "uuid": "7d362379-b321-4bf5-bb63-0f72915334b3",
    "hitokoto": "报君黄金台上意，提携玉龙为君死。",
    "type": "g",
    "from": "雁门太守行",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547732327",
    "length": 16
  },
  {
    "id": 4236,
    "uuid": "ab79ee70-dc3b-4ebd-ac03-30c4cc249ef5",
    "hitokoto": "常记溪亭日暮，沉醉不知归路。兴尽晚回舟，误入藕花深处。",
    "type": "g",
    "from": "如梦令",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788222",
    "length": 27
  },
  {
    "id": 4247,
    "uuid": "5cd55a15-f2c6-40b6-b170-dd8b48b1dae1",
    "hitokoto": " To boldly go where no one has gone before.",
    "type": "g",
    "from": "星际迷航",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547790262",
    "length": 43
  },
  {
    "id": 4248,
    "uuid": "f9dce5bb-9f6c-4ab3-aeb3-346a137e54a2",
    "hitokoto": "撞上南墙终于悔悟的我，从未感觉如此失落。",
    "type": "g",
    "from": "星际迷航",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547790793",
    "length": 20
  },
  {
    "id": 4253,
    "uuid": "e13f1c08-e271-4b1d-84bf-6b99300261b1",
    "hitokoto": "命运他无法让我跪地求饶，就算鲜血撒满了怀抱。",
    "type": "g",
    "from": "追梦赤子心",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547798090",
    "length": 22
  },
  {
    "id": 4254,
    "uuid": "ebd8f211-e7e3-418a-be17-4c5fd9c3a63c",
    "hitokoto": "宇宙中唯有两件事物是无限的：那就是宇宙的大小与人的愚蠢。而宇宙的大小我却不能肯定。",
    "type": "g",
    "from": "爱因斯坦",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547798327",
    "length": 41
  },
  {
    "id": 4255,
    "uuid": "3ac99527-29a1-4b4c-829e-381c2150c023",
    "hitokoto": "轻关易道，通商宽农。",
    "type": "g",
    "from": "晋语",
    "from_who": null,
    "creator": "赏花不如吃团子",
    "creator_uid": 2641,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547888984",
    "length": 10
  },
  {
    "id": 4263,
    "uuid": "cee0be29-f98e-4559-93b2-62c462ffc4b1",
    "hitokoto": "梦は终わり目を觉ます时、绝望や希望も同时に目を觉ました。",
    "type": "g",
    "from": "TAKA",
    "from_who": null,
    "creator": "YukoAsuka",
    "creator_uid": 2253,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548697153",
    "length": 28
  },
  {
    "id": 4272,
    "uuid": "10642c7d-0e24-4fd5-95d7-6abbe78257c5",
    "hitokoto": "纵是年少风流可入画，却也自成风骨难笔拓。",
    "type": "g",
    "from": "永安调",
    "from_who": null,
    "creator": "不喝温水",
    "creator_uid": 2723,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549435122",
    "length": 20
  },
  {
    "id": 4274,
    "uuid": "1e2cec78-1cb4-4003-a173-83ff5f373a0e",
    "hitokoto": "forget-me-not，Ash to ash, dust to dust，どうか忘れないで",
    "type": "g",
    "from": "forget–me–not",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549455245",
    "length": 47
  },
  {
    "id": 4283,
    "uuid": "bf8f4783-7ed5-4295-8aef-9184860faede",
    "hitokoto": "生生不息，繁荣昌盛。",
    "type": "g",
    "from": "星际迷航",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549888324",
    "length": 10
  },
  {
    "id": 4302,
    "uuid": "56619411-5478-477b-b29f-08de9be461b0",
    "hitokoto": "征服可能会受挫，但好奇从未停息。",
    "type": "g",
    "from": "2001太空漫游",
    "from_who": null,
    "creator": "蒟蒻XZY",
    "creator_uid": 877,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550633946",
    "length": 16
  },
  {
    "id": 4304,
    "uuid": "ba5c8cf8-96ca-4a18-b128-80727c765140",
    "hitokoto": "No puzzle that couldn't be solved!",
    "type": "g",
    "from": "平面国",
    "from_who": null,
    "creator": "蒟蒻XZY",
    "creator_uid": 877,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550939303",
    "length": 34
  },
  {
    "id": 4312,
    "uuid": "891509b8-573e-41e9-9fce-78b070d5112b",
    "hitokoto": "科学就是去确定未知的事物",
    "type": "g",
    "from": "星际穿越",
    "from_who": null,
    "creator": "taskmag",
    "creator_uid": 3147,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557409423",
    "length": 12
  },
  {
    "id": 4317,
    "uuid": "6138ea30-9f5f-4a65-8917-c69d04ca7675",
    "hitokoto": "还没开始，就已经结束了吗……",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557299870",
    "length": 14
  },
  {
    "id": 4322,
    "uuid": "5d4b5c19-e3c8-4558-bd3f-24e134361c65",
    "hitokoto": "创作一部动画也就是创造一个虚拟的世界，这个世界慰藉着那些暂时失去勇气的、与残忍现实搏斗的灵魂。",
    "type": "g",
    "from": "宫崎骏",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556780946",
    "length": 47
  },
  {
    "id": 4340,
    "uuid": "90ae473f-c897-4660-95ae-528057eacfdc",
    "hitokoto": "问苍茫大地,谁主沉浮?",
    "type": "g",
    "from": "诗词",
    "from_who": null,
    "creator": "smallfang",
    "creator_uid": 2840,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551690767",
    "length": 11
  },
  {
    "id": 4343,
    "uuid": "d55a915c-4756-4231-85cc-9fe452fae625",
    "hitokoto": "如果我们有再三思考的机会，几乎没有一件事情是不能被简化的。",
    "type": "g",
    "from": "高德纳",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551794743",
    "length": 29
  },
  {
    "id": 4344,
    "uuid": "5f199e50-dabc-460a-bb91-22f71ab89f4b",
    "hitokoto": "我愿披挂长风扬鞭策马 去看去唱那四海之大",
    "type": "g",
    "from": "最大化+",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551869246",
    "length": 20
  },
  {
    "id": 4345,
    "uuid": "0739442e-4ebf-48c6-a4e4-d80020eeb2f1",
    "hitokoto": "流水线上的量产品迟早退场 我就做我的孤品随心所欲好了",
    "type": "g",
    "from": "最大化+",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551869402",
    "length": 26
  },
  {
    "id": 4346,
    "uuid": "15444eda-9f23-4f03-a5ce-c7d747304fd3",
    "hitokoto": "无法拒绝的礼物 决定了我的轮廓什么样 却不能把我的心也捆绑",
    "type": "g",
    "from": "最大化+",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551869488",
    "length": 29
  },
  {
    "id": 4348,
    "uuid": "b357e735-c398-4d4a-a475-bf9fd09b7055",
    "hitokoto": "未来不是被给予的，而是自己争取的",
    "type": "g",
    "from": "尼尔：机械纪元",
    "from_who": null,
    "creator": "moto350",
    "creator_uid": 2861,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551932443",
    "length": 16
  },
  {
    "id": 4351,
    "uuid": "79a42c45-42e9-4786-9272-7b994eb4b818",
    "hitokoto": "人的生活有许多楼层，眼睛看得见的只是一种可能性，但心中则汇集着所有可能性。",
    "type": "g",
    "from": "卡夫卡书信日记选",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552317981",
    "length": 37
  },
  {
    "id": 4352,
    "uuid": "361f822b-eea1-4715-b988-474617e35e45",
    "hitokoto": "唯有爱与梦想不可辜负",
    "type": "g",
    "from": "爱与梦想",
    "from_who": null,
    "creator": "执笔乄画倾城",
    "creator_uid": 2884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552391113",
    "length": 10
  },
  {
    "id": 4362,
    "uuid": "96485a63-94d6-4584-823e-504f2c0fe434",
    "hitokoto": "竹杖芒鞋轻胜马，谁怕？一蓑烟雨任平生。",
    "type": "g",
    "from": "定风波",
    "from_who": null,
    "creator": "Jason_Lee",
    "creator_uid": 3117,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556092195",
    "length": 19
  },
  {
    "id": 4368,
    "uuid": "4db064ec-9cfb-445e-be1e-abd4dd1b0f3b",
    "hitokoto": "如果你给别人讲解程序时，看到对方点头了，那你就拍他一下，他肯定睡觉了。",
    "type": "g",
    "from": "艾伦·佩利",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551794485",
    "length": 35
  },
  {
    "id": 4369,
    "uuid": "239ff6a0-c559-4635-8241-c42b7939737e",
    "hitokoto": "依然记得从你口中说出再见坚决如铁",
    "type": "g",
    "from": "黄昏",
    "from_who": null,
    "creator": "memset0",
    "creator_uid": 2507,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551772960",
    "length": 16
  },
  {
    "id": 4373,
    "uuid": "92294d89-a2c2-4c54-a816-de9c82fb204a",
    "hitokoto": "月色与雪色之间，你是第三种绝色。",
    "type": "g",
    "from": "绝色",
    "from_who": null,
    "creator": "阑珊",
    "creator_uid": 3002,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554535104",
    "length": 16
  },
  {
    "id": 4385,
    "uuid": "fe1ca73e-47c0-4d63-9d43-2b4050a3178f",
    "hitokoto": "下次你路过 ，人间已无我。",
    "type": "g",
    "from": "欢呼哈雷",
    "from_who": null,
    "creator": "阑珊",
    "creator_uid": 3002,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554535024",
    "length": 13
  },
  {
    "id": 4386,
    "uuid": "b4092393-18cb-4bbe-813f-7c6275bbf7ca",
    "hitokoto": "愿各位程序员都能记住，输出第一条hello world时候的心情。坚持下去，你的每一条代码都在默默的改变世界，加油！加油！加油！",
    "type": "g",
    "from": "角落里的程序员",
    "from_who": null,
    "creator": "Lo1i",
    "creator_uid": 2381,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546742805",
    "length": 64
  },
  {
    "id": 4392,
    "uuid": "ed81dda7-1234-4be0-b11b-8e5307946eba",
    "hitokoto": "いつだって 信じて 可能性 は無限大",
    "type": "g",
    "from": "i BELIEVE～星に願いを",
    "from_who": null,
    "creator": "kiseopt",
    "creator_uid": 202,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553339614",
    "length": 18
  },
  {
    "id": 4393,
    "uuid": "6b57d293-b169-4205-9fe7-e6583a400d29",
    "hitokoto": "花火みたいな綺麗な人になれば 良かったかな",
    "type": "g",
    "from": "ルミネセンス",
    "from_who": null,
    "creator": "kiseopt",
    "creator_uid": 202,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553340266",
    "length": 21
  },
  {
    "id": 4394,
    "uuid": "94b88c9e-2f69-4cad-a764-cebdbe588e6a",
    "hitokoto": "逢うべき糸に出逢えることを 人は仕合わせと呼びます",
    "type": "g",
    "from": "糸",
    "from_who": null,
    "creator": "kiseopt",
    "creator_uid": 202,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553340966",
    "length": 25
  },
  {
    "id": 4408,
    "uuid": "90961b27-a74b-47a0-b54d-acf91127a3c1",
    "hitokoto": "到底是孤独的人强大，还是强大的人孤独。",
    "type": "g",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553906845",
    "length": 19
  },
  {
    "id": 4410,
    "uuid": "37094690-22e5-4807-82db-8f09968baca6",
    "hitokoto": "最怕一生碌碌无为，还安慰自己平凡可贵。",
    "type": "g",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553906955",
    "length": 19
  },
  {
    "id": 4411,
    "uuid": "3c0ce755-eee1-4432-b8ee-bd5b1ab72b38",
    "hitokoto": "地球还在旋转，太阳照常升起。我还有梦，尚待实现。",
    "type": "g",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553906975",
    "length": 24
  },
  {
    "id": 4412,
    "uuid": "4aef9022-fe2f-4a8d-a880-9f27b47b9274",
    "hitokoto": "I never change whatever U change.",
    "type": "g",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553907127",
    "length": 33
  },
  {
    "id": 4413,
    "uuid": "d2e6f1c6-4f49-4348-895e-966d766b06e3",
    "hitokoto": "I am a slow walker, but I never walk backwards.我走的很慢,但我从来不走回头路.",
    "type": "g",
    "from": "亚伯拉罕·林肯",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553907002",
    "length": 63
  },
  {
    "id": 4419,
    "uuid": "6d0f8ff2-c054-433f-9147-7fc7e303e7cf",
    "hitokoto": "笑口常开，好彩自然来！",
    "type": "g",
    "from": "好彩妹",
    "from_who": null,
    "creator": "三清大帝在上",
    "creator_uid": 2990,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554346451",
    "length": 11
  },
  {
    "id": 4422,
    "uuid": "4064dd95-b387-406c-8f14-8caee5244134",
    "hitokoto": "这永远闪光的梦想，穿过每一个清晨，每一个不眠夜晚。",
    "type": "g",
    "from": "许巍·无尽光芒",
    "from_who": null,
    "creator": "泷涯",
    "creator_uid": 1291,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555337885",
    "length": 25
  },
  {
    "id": 4423,
    "uuid": "230c03e1-5928-446c-bddf-6a8d3056c885",
    "hitokoto": "人生若只如初见，何事秋风悲画扇。",
    "type": "g",
    "from": "木兰词·拟古决绝词柬友",
    "from_who": null,
    "creator": "哈鹿噶kida",
    "creator_uid": 3040,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555501376",
    "length": 16
  },
  {
    "id": 4428,
    "uuid": "63a1ce47-4ca5-49f9-a43a-7d0a6815326f",
    "hitokoto": "南风知我意，吹梦到西洲。",
    "type": "g",
    "from": "西洲曲",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556070216",
    "length": 12
  },
  {
    "id": 4435,
    "uuid": "746f0bba-fd90-4084-858e-eb6b49c36b96",
    "hitokoto": "旅游的意义在于，看那些你不曾经历过的事情，见那些你可能永远不会再见的人。",
    "type": "g",
    "from": "柯宝宝",
    "from_who": null,
    "creator": "kelihong520",
    "creator_uid": 3227,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557767872",
    "length": 36
  },
  {
    "id": 4436,
    "uuid": "b0c32247-69aa-4351-b4de-81946109682b",
    "hitokoto": "背上背包，带上行囊，去你的世界旅行。",
    "type": "g",
    "from": "柯宝宝",
    "from_who": null,
    "creator": "kelihong520",
    "creator_uid": 3227,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557767907",
    "length": 18
  },
  {
    "id": 4444,
    "uuid": "848e4f77-6e1d-46bb-8b47-2b8d709daa88",
    "hitokoto": "世界上一成不变的东西，只有“任何事物都是在不断变化的”这条真理。",
    "type": "g",
    "from": "斯里兰卡",
    "from_who": null,
    "creator": "纵横天下",
    "creator_uid": 3268,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558608031",
    "length": 32
  },
  {
    "id": 4459,
    "uuid": "92ee639c-dce3-4148-82bd-3ffa3f74e2c1",
    "hitokoto": "白马入芦花，银碗里盛雪。",
    "type": "g",
    "from": "日本和歌",
    "from_who": null,
    "creator": "大雪封山",
    "creator_uid": 3738,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566616691",
    "length": 12
  },
  {
    "id": 4460,
    "uuid": "b9d52016-05d9-4d46-b087-14093a0430fb",
    "hitokoto": "如果最开始我没欺骗你，我们会怎样？",
    "type": "g",
    "from": "原创",
    "from_who": null,
    "creator": "星宿凌雾",
    "creator_uid": 3748,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566660644",
    "length": 17
  },
  {
    "id": 4486,
    "uuid": "06ac78b6-0d0f-42b1-b423-6ed140ac8a6a",
    "hitokoto": "Hand down,man down.",
    "type": "g",
    "from": "德鲁大叔",
    "from_who": null,
    "creator": "Uncle_drew",
    "creator_uid": 3364,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560511306",
    "length": 19
  },
  {
    "id": 4492,
    "uuid": "9035c076-2ac1-45fd-b3d3-16dd1c3c53d4",
    "hitokoto": "形而上者谓之道，形而下者谓之器。",
    "type": "g",
    "from": "《易经》",
    "from_who": null,
    "creator": "MILLOPE",
    "creator_uid": 3119,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560865357",
    "length": 16
  },
  {
    "id": 4506,
    "uuid": "ae3f9c70-33dc-4b58-9c18-5f061a094206",
    "hitokoto": "一直都在躲雨，你有考虑过雨的感受吗？",
    "type": "g",
    "from": "欢欢",
    "from_who": null,
    "creator": "hero",
    "creator_uid": 3181,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562134622",
    "length": 18
  },
  {
    "id": 4507,
    "uuid": "eb85b1bc-3785-4dfa-b3a4-39d9660094b5",
    "hitokoto": "I AK IOI",
    "type": "g",
    "from": "ypy\u0026zyd\u0026ym\u0026ygy",
    "from_who": null,
    "creator": "Steven_Meng",
    "creator_uid": 3449,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562140877",
    "length": 8
  },
  {
    "id": 4512,
    "uuid": "15ef0e85-d013-475c-a725-85bdd52608ee",
    "hitokoto": "不驰于空想，不骛于虚声。",
    "type": "g",
    "from": "李大钊",
    "from_who": null,
    "creator": "蓝白条纹的天空",
    "creator_uid": 3477,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562580132",
    "length": 12
  },
  {
    "id": 4526,
    "uuid": "0d303426-f760-4135-b653-82b052f89739",
    "hitokoto": "你启唇似又要咏遍上邪，说的却是：“我愿与君绝。”",
    "type": "g",
    "from": "上邪",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562980941",
    "length": 24
  },
  {
    "id": 4553,
    "uuid": "c2c39815-9ec1-4afa-8eec-27eea65585fb",
    "hitokoto": "不要想着有一份稳定的工作，而是有让生活稳定的本事。",
    "type": "g",
    "from": "RtyXmd",
    "from_who": null,
    "creator": "RtyXmd",
    "creator_uid": 3544,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563862636",
    "length": 25
  },
  {
    "id": 4554,
    "uuid": "179665d7-6739-47bb-8391-05f5298dd348",
    "hitokoto": "稳定不是一辈子拴在一个单位，而是有本事去任何单位。",
    "type": "g",
    "from": "RtyXmd",
    "from_who": null,
    "creator": "RtyXmd",
    "creator_uid": 3544,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563862699",
    "length": 25
  },
  {
    "id": 4564,
    "uuid": "c78f853d-63ca-4687-a8fd-a498bd89a8da",
    "hitokoto": "“你知道，我以前是红色的。和我喷出的火焰一样的赤红。那些日子真是美好啊。”",
    "type": "g",
    "from": "scp-3844",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564316816",
    "length": 37
  },
  {
    "id": 4566,
    "uuid": "a2954057-5f52-45d7-b694-b322a21966d4",
    "hitokoto": "且将新火试新茶，诗酒趁年华",
    "type": "g",
    "from": "来自网络",
    "from_who": null,
    "creator": "牙人圭uu",
    "creator_uid": 3596,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564899782",
    "length": 13
  },
  {
    "id": 4572,
    "uuid": "86599911-90d1-44fe-bc37-77efd5ca941b",
    "hitokoto": "祈祷奇迹，其实不如无尽的练习。",
    "type": "g",
    "from": "林俊杰《黑键》",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565491202",
    "length": 15
  },
  {
    "id": 4575,
    "uuid": "23c31d69-a094-41be-8687-76dd6b958db4",
    "hitokoto": "如果再也见不到你，祝你早安、午安、晚安。",
    "type": "g",
    "from": "楚门的世界",
    "from_who": null,
    "creator": "vien blus",
    "creator_uid": 3650,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565677228",
    "length": 20
  },
  {
    "id": 4576,
    "uuid": "d3fc4069-3591-40de-ba20-f868612fe422",
    "hitokoto": "欲戴王冠，必承其重。",
    "type": "g",
    "from": "亨利四世",
    "from_who": null,
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565682617",
    "length": 10
  },
  {
    "id": 4588,
    "uuid": "33b70aae-a6ad-4909-9c00-dd7f901ee21c",
    "hitokoto": "讨厌酒的味道，却爱上醉的感觉。",
    "type": "g",
    "from": "我的",
    "from_who": null,
    "creator": "小璐迷了路",
    "creator_uid": 3742,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566625809",
    "length": 15
  },
  {
    "id": 4592,
    "uuid": "ec289476-1f52-4e04-a189-5ff3616aebac",
    "hitokoto": "今天也要开心哟~",
    "type": "g",
    "from": "小千",
    "from_who": null,
    "creator": "四斤",
    "creator_uid": 3770,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566870153",
    "length": 8
  },
  {
    "id": 4599,
    "uuid": "e25df483-9a33-4838-a314-945cb9b5b93f",
    "hitokoto": "爱你我也不在是那个幼稚的少年。",
    "type": "g",
    "from": "那个女孩",
    "from_who": null,
    "creator": "陵宇",
    "creator_uid": 3791,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567062165",
    "length": 15
  },
  {
    "id": 4619,
    "uuid": "b043d1d5-c931-4ce7-9ea4-0fd032a527df",
    "hitokoto": "醉后不知天在水 满船清梦压星河",
    "type": "g",
    "from": "唐温如",
    "from_who": null,
    "creator": "allenwang",
    "creator_uid": 3848,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567671077",
    "length": 15
  },
  {
    "id": 4620,
    "uuid": "ed50a482-ca39-45ac-ae62-944b2b11d938",
    "hitokoto": "赌书消得泼茶香，当时只道是寻常",
    "type": "g",
    "from": "纳兰性德",
    "from_who": null,
    "creator": "旒虬",
    "creator_uid": 3849,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567673987",
    "length": 15
  },
  {
    "id": 4631,
    "uuid": "a464bb86-5249-438f-8162-16cd6ea9a1ae",
    "hitokoto": "世间无限丹青手，一片伤心画不成。",
    "type": "g",
    "from": "金陵晚望",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567971033",
    "length": 16
  },
  {
    "id": 4635,
    "uuid": "5ece9fae-8e2d-4581-8812-6e7d35bf80ab",
    "hitokoto": "爱你所爱，行你所行，听从你心，无问西东。",
    "type": "g",
    "from": "无问西东",
    "from_who": null,
    "creator": "山河故人",
    "creator_uid": 3902,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568192471",
    "length": 20
  },
  {
    "id": 4663,
    "uuid": "2fdccb8a-fe0b-41ce-8170-c1a101ca97d9",
    "hitokoto": "不以物喜，不以己悲。",
    "type": "g",
    "from": "岳阳楼记",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569327326",
    "length": 10
  },
  {
    "id": 4664,
    "uuid": "9af847be-68b0-4463-982f-8089a51ec550",
    "hitokoto": "人有悲欢离合，月有阴晴圆缺，此事古难全，但愿人长久，千里共婵娟。",
    "type": "g",
    "from": "水调歌头",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569327387",
    "length": 32
  },
  {
    "id": 4665,
    "uuid": "aa1aa488-269e-4b2b-856b-b9c6f9de992d",
    "hitokoto": "长风破浪会有时，直挂云帆济沧海。",
    "type": "g",
    "from": "行路难",
    "from_who": "李白",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569327421",
    "length": 16
  },
  {
    "id": 4666,
    "uuid": "ae97af26-231f-4b62-ae6a-92db4dff4c20",
    "hitokoto": "明月装饰了你的窗子，你装饰了别人的梦。",
    "type": "g",
    "from": "断章",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569328047",
    "length": 19
  },
  {
    "id": 4675,
    "uuid": "f85bed34-32f6-4c1c-a739-aec0fdca78e9",
    "hitokoto": "不可盲目期待，不可执念过深，不可用力过猛。",
    "type": "g",
    "from": "小感",
    "from_who": null,
    "creator": "哇哈哈",
    "creator_uid": 3999,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569660003",
    "length": 21
  },
  {
    "id": 4677,
    "uuid": "5fa618f3-7a63-40fa-9e95-96da7de7f860",
    "hitokoto": "其实不用担心，你们中的很多人一辈子都不会遇见你梦想的真爱。只会因为害怕孤独地死去而选择随便找个人，互相饲养。",
    "type": "g",
    "from": "塞内加",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569775238",
    "length": 54
  },
  {
    "id": 4679,
    "uuid": "8a039009-10ef-4136-8263-170aef70f329",
    "hitokoto": "为什么我的眼里常含泪水？因为我对这土地爱的深沉。",
    "type": "g",
    "from": "我爱这土地",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569846565",
    "length": 24
  },
  {
    "id": 4687,
    "uuid": "d257ca4d-6175-4699-ad51-168ac0e87149",
    "hitokoto": "明明喜欢，却要装作无所事事，等到已从身边离去，而来追悔莫及。",
    "type": "g",
    "from": "网络",
    "from_who": "丁先生",
    "creator": "丁先生",
    "creator_uid": 3960,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1569159812",
    "length": 30
  },
  {
    "id": 4691,
    "uuid": "b6be808b-5fa1-431b-922e-6efdc754de4b",
    "hitokoto": "善為士者，不武；善战者，不怒；善胜敌者，不与；善用人者，為之下。",
    "type": "g",
    "from": "道德经",
    "from_who": null,
    "creator": "你家炸了",
    "creator_uid": 3557,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1569659800",
    "length": 32
  },
  {
    "id": 4702,
    "uuid": "75e46287-a49b-4a71-b60a-1524ff6296f6",
    "hitokoto": "逝者如斯，不舍昼夜。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "气质",
    "creator_uid": 4040,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1570606318",
    "length": 10
  },
  {
    "id": 4709,
    "uuid": "f3d7afde-6368-4c6b-a739-e7ca36e83d40",
    "hitokoto": "曾经沧海难为水，除却巫山不是云。取次花丛懒回顾，半缘修道半缘君。",
    "type": "g",
    "from": "离思",
    "from_who": null,
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571141417",
    "length": 32
  },
  {
    "id": 4784,
    "uuid": "2ef883d1-5fe6-4c2b-a9a8-b8f9abf19df0",
    "hitokoto": "只要一想起一生中最后悔的事，梅花便落下来了，梅花真的落下来了，我们在粗粝的生活中慢慢变老，不变的是当年那颗热爱生活的心。",
    "type": "g",
    "from": "素雅-",
    "from_who": null,
    "creator": "素雅",
    "creator_uid": 4077,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571190666",
    "length": 60
  },
  {
    "id": 4787,
    "uuid": "a6e73829-eba7-47eb-838d-a9944029555c",
    "hitokoto": "我的手机明明没有坏掉，可是她为什么没给我打电话呢？",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "WDQ",
    "creator_uid": 4137,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571971993",
    "length": 25
  },
  {
    "id": 4790,
    "uuid": "c7348e92-fa05-429c-8d42-95ba9514df25",
    "hitokoto": "掠过浮霞光影，最后能赢下生活的，还是我们。",
    "type": "g",
    "from": "klssxbc0002",
    "from_who": null,
    "creator": "Dead_Walker",
    "creator_uid": 4110,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571640828",
    "length": 21
  },
  {
    "id": 4798,
    "uuid": "47404f2e-3ce0-4386-b290-cbe265ba3000",
    "hitokoto": "无眼界，乃至无意识界，无无明，亦无无明尽，乃至无老死，亦无老死尽。",
    "type": "g",
    "from": "般若波罗蜜多心经",
    "from_who": null,
    "creator": "Larry",
    "creator_uid": 4073,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571147191",
    "length": 33
  },
  {
    "id": 4799,
    "uuid": "0f4e4ea8-3809-4738-a138-922e51fa2c3b",
    "hitokoto": "人于浮世，独来独往，独生独死，苦乐自当，无有代者。",
    "type": "g",
    "from": "《无量寿经》",
    "from_who": null,
    "creator": "心软爸爸",
    "creator_uid": 4105,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571539336",
    "length": 25
  },
  {
    "id": 4839,
    "uuid": "28385116-f1c6-48dc-aafc-a49af65724e7",
    "hitokoto": "人生就像一杯茶，不会苦一辈子，但会苦一阵子",
    "type": "g",
    "from": "启东中学作业本",
    "from_who": null,
    "creator": "1212967",
    "creator_uid": 3817,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572737355",
    "length": 21
  },
  {
    "id": 4861,
    "uuid": "f2d839c1-30e1-4002-a704-0b7e2c49068a",
    "hitokoto": "世情薄，人情恶，两送黄昏花易落。晓风残，泪痕残。欲笺心事，独倚斜阑。难，难，难！",
    "type": "g",
    "from": "钗头凤·世情薄",
    "from_who": null,
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571141913",
    "length": 40
  },
  {
    "id": 4862,
    "uuid": "f33f3423-448d-4dd3-a267-d0d82412c2a3",
    "hitokoto": "人成各，今非昨，病魂常似秋千索。角声寒，夜阑珊。怕人询问，咽泪装欢。瞒，瞒，瞒！",
    "type": "g",
    "from": "钗头凤·世情薄",
    "from_who": null,
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571142004",
    "length": 40
  },
  {
    "id": 4901,
    "uuid": "c10604fe-de3c-494f-90d8-c27e7a7bed90",
    "hitokoto": "永远相信，美好的事情即将发生。",
    "type": "g",
    "from": "小米公司",
    "from_who": null,
    "creator": "DreamerT",
    "creator_uid": 4257,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573486289",
    "length": 15
  },
  {
    "id": 4942,
    "uuid": "39ad5ee1-7530-404f-86c2-066fe1480ed9",
    "hitokoto": "世界本就不完美，我们不过顺势而为",
    "type": "g",
    "from": "毕淑敏",
    "from_who": null,
    "creator": "清茶-烈酒°",
    "creator_uid": 4426,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575645307",
    "length": 16
  },
  {
    "id": 4943,
    "uuid": "f68bbe3a-33c4-4b63-9989-dd66be3eae4d",
    "hitokoto": "新时代，共享未来！",
    "type": "g",
    "from": "中国国际进口博览会",
    "from_who": null,
    "creator": "狗毛小窝",
    "creator_uid": 4209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575696930",
    "length": 9
  },
  {
    "id": 4958,
    "uuid": "58dd4faf-1dce-499a-90d3-a891720b38e5",
    "hitokoto": "人这种生物，无论是谁，切开来剥了皮后都只是一团肉而已，死了就知道了。",
    "type": "g",
    "from": "其他",
    "from_who": null,
    "creator": "SpringHan",
    "creator_uid": 4473,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576313536",
    "length": 34
  },
  {
    "id": 4998,
    "uuid": "55938743-4d92-4317-b32e-ceecac8d76df",
    "hitokoto": "你只看到了第二层，而你只把我想成了第一层，实际上我是第五层",
    "type": "g",
    "from": "金牌讲师大司马",
    "from_who": "大司马",
    "creator": "losting",
    "creator_uid": 4867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581449719",
    "length": 29
  },
  {
    "id": 4999,
    "uuid": "a81d9769-8f0e-40a7-b0d5-adcb6bffa3f3",
    "hitokoto": "因为你不会，所以你才会",
    "type": "g",
    "from": "金牌讲师大司马",
    "from_who": "大司马",
    "creator": "losting",
    "creator_uid": 4867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581449429",
    "length": 11
  },
  {
    "id": 5024,
    "uuid": "68e1ff50-ed76-4be1-950e-325cf2758c20",
    "hitokoto": "民谣有三：爱情 理想 远方   听者有三：孤独 平庸 落魄",
    "type": "g",
    "from": "殿下",
    "from_who": null,
    "creator": "殿下",
    "creator_uid": 4507,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576821449",
    "length": 29
  },
  {
    "id": 5028,
    "uuid": "5a1017a4-f50c-43ae-9d1a-a3f0ada68d55",
    "hitokoto": "你已经奔走了许久，坚持最后一战，你就是冠军。",
    "type": "g",
    "from": "南先生",
    "from_who": null,
    "creator": "南先生",
    "creator_uid": 4487,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576485950",
    "length": 22
  },
  {
    "id": 5032,
    "uuid": "647477f5-de92-4a94-99c9-ed28a8d0fdc7",
    "hitokoto": "我独自度过了太多的时光,沉默已成一种习惯。",
    "type": "g",
    "from": "夜航西飞",
    "from_who": null,
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576129068",
    "length": 21
  },
  {
    "id": 5033,
    "uuid": "363f1e14-2a09-40d9-9f91-ce70bd5b0942",
    "hitokoto": "失去的生命不能复归，也用不着复归。",
    "type": "g",
    "from": "留德十年",
    "from_who": null,
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576129301",
    "length": 17
  },
  {
    "id": 5034,
    "uuid": "fd3f36a6-a9a0-4add-af1b-d9d63c64e459",
    "hitokoto": "只要还在人间，你就不会完全麻木。",
    "type": "g",
    "from": "行板如歌",
    "from_who": null,
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576129837",
    "length": 16
  },
  {
    "id": 5035,
    "uuid": "0ba66d9f-5f68-496d-984f-63f3ac8c50c1",
    "hitokoto": "无边的海洋里漂流的小船，不知何时就会被狂风所倾覆；而小船上平凡的我们，也只能怀着渺茫的希望，跟随着舵手指引的航向前行吧。",
    "type": "g",
    "from": "十二省联考 2019",
    "from_who": null,
    "creator": "Tantantann",
    "creator_uid": 4542,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1577280736",
    "length": 60
  },
  {
    "id": 5043,
    "uuid": "c6af7245-fe16-4290-bc30-d037b94563ce",
    "hitokoto": "跑得快不一定赢，不跌跟头才是成功",
    "type": "g",
    "from": "8848太监手机",
    "from_who": null,
    "creator": "泠泫凝",
    "creator_uid": 4598,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578204401",
    "length": 16
  },
  {
    "id": 5058,
    "uuid": "34fc9c6f-a295-4814-a784-4df1621a2bf8",
    "hitokoto": "事物的发展是前进性与曲折性的统一",
    "type": "g",
    "from": "Jane",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579144602",
    "length": 16
  },
  {
    "id": 5059,
    "uuid": "da5308f2-4f21-4652-a007-d362900ccaa3",
    "hitokoto": "跑下去,天自己会亮",
    "type": "g",
    "from": "New Balance广告片台词",
    "from_who": null,
    "creator": "alina_07",
    "creator_uid": 4680,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579420609",
    "length": 9
  },
  {
    "id": 5086,
    "uuid": "c5d5e25f-9d1c-4d5e-bf3e-e69b7db024d4",
    "hitokoto": "即使这些回忆使我感到悲伤，我也必须前进，相信未来。即使是在我感到了我的孤单，即将失去所有的希望，这份回忆，也使我更加坚强。",
    "type": "g",
    "from": "Shelter",
    "from_who": "Porter Robinson",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582468972",
    "length": 61
  },
  {
    "id": 5114,
    "uuid": "3a6893c9-6e1e-4ace-8d65-ed6b79bc2858",
    "hitokoto": "太阳请不要晒黑我的皮肤，请晒黑我爸爸妈妈的头发。",
    "type": "g",
    "from": "酷狗音乐",
    "from_who": null,
    "creator": "凡为过往，皆为序章",
    "creator_uid": 4914,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581864791",
    "length": 24
  },
  {
    "id": 5118,
    "uuid": "b6ed7318-f33a-462e-984b-127ac1c374bc",
    "hitokoto": "白日不到处，青春恰自来。苔花如米小，也学牡丹开。",
    "type": "g",
    "from": "苔",
    "from_who": "袁枚",
    "creator": "zqfzqf",
    "creator_uid": 4716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579912512",
    "length": 24
  },
  {
    "id": 5121,
    "uuid": "f53d53a0-bea1-499c-87cb-eab2ad8ba371",
    "hitokoto": "不负韶华，不忘初心。",
    "type": "g",
    "from": "Jane",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579144697",
    "length": 10
  },
  {
    "id": 5132,
    "uuid": "c0b7ce96-dcbf-42a0-8d02-3aa6e9bdf682",
    "hitokoto": "你写下的每一个bug，都是人类反抗被人工智能统治的一颗子弹!",
    "type": "g",
    "from": "辣椒の酱",
    "from_who": null,
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1574691698",
    "length": 30
  },
  {
    "id": 5145,
    "uuid": "1713d4b7-8361-48dc-b2d6-9686d9099b06",
    "hitokoto": "然后知生于忧患，而死于安乐也。",
    "type": "g",
    "from": "孟子",
    "from_who": null,
    "creator": "狗毛小窝",
    "creator_uid": 4209,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1577540116",
    "length": 15
  },
  {
    "id": 5146,
    "uuid": "2b0f2bc9-09fe-4a05-bcc6-f48de1332e67",
    "hitokoto": "我们所可以自慰的，想来想去，也还是所谓对于将来的希望。希望是附丽于存在的，有存在，便有希望，有希望，便是光明。",
    "type": "g",
    "from": "十二省联考 2019",
    "from_who": null,
    "creator": "Tantantann",
    "creator_uid": 4542,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1577281223",
    "length": 55
  },
  {
    "id": 5197,
    "uuid": "b63aa18e-6f3d-4a76-8bb3-467bfe74335b",
    "hitokoto": "今天的南京应该很挤吧，毕竟有30万人要回家。",
    "type": "g",
    "from": "心印杂记",
    "from_who": null,
    "creator": "心印001",
    "creator_uid": 3471,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583224749",
    "length": 22
  },
  {
    "id": 5249,
    "uuid": "281d9aa6-5b69-4d63-a281-81a83f734452",
    "hitokoto": "我们在青春里遇见，写下纯白的誓言，在夏天来临之前。",
    "type": "g",
    "from": "在青春里遇见",
    "from_who": null,
    "creator": "狂三游六花。",
    "creator_uid": 5315,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583809501",
    "length": 25
  },
  {
    "id": 5332,
    "uuid": "89f4b763-77af-4980-a0d6-ef400ebd6ea1",
    "hitokoto": "嗨！别来无恙啊！",
    "type": "g",
    "from": "Windows10提示语",
    "from_who": "微软",
    "creator": "狗毛小窝",
    "creator_uid": 4209,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584711074",
    "length": 8
  },
  {
    "id": 5339,
    "uuid": "fe80249f-e7aa-4967-a257-a14399c62bde",
    "hitokoto": "我不后悔我曾爱过，只是天涯从此寂寞，短暂的幸福拥有就足够，只要舍得就会快了，会快乐。",
    "type": "g",
    "from": "我不后悔",
    "from_who": "郑源",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584956902",
    "length": 42
  },
  {
    "id": 5341,
    "uuid": "c8565e27-5387-4aa1-86b3-d7c286bb6bc1",
    "hitokoto": "善思博学，努力进取。",
    "type": "g",
    "from": "张万军",
    "from_who": "张万军",
    "creator": "张一",
    "creator_uid": 5013,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1585024571",
    "length": 10
  },
  {
    "id": 5371,
    "uuid": "6f34e10e-abcb-4d1d-8f3f-47c89117f3a4",
    "hitokoto": "My love for you always grow, with passing year.",
    "type": "g",
    "from": "Eudic",
    "from_who": "56",
    "creator": "56",
    "creator_uid": 5680,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585450849",
    "length": 47
  },
  {
    "id": 5377,
    "uuid": "a545deba-7194-4ca8-8fca-10f9a1982f26",
    "hitokoto": "梦想和现实，中间隔着一条泥泞的路，什么样的结果，取决于脚！",
    "type": "g",
    "from": "龙城浪子",
    "from_who": null,
    "creator": "龙尧",
    "creator_uid": 5594,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585025131",
    "length": 29
  },
  {
    "id": 5385,
    "uuid": "6793d741-6cf5-4bed-a79a-adc4dc737958",
    "hitokoto": "任何时代的诗歌都是关于人、人的生存方式、人的存在境遇的叩问，关于人生价值与意义的探寻。",
    "type": "g",
    "from": "龙城浪子",
    "from_who": null,
    "creator": "龙尧",
    "creator_uid": 5594,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585114186",
    "length": 43
  },
  {
    "id": 5404,
    "uuid": "d239d812-17b4-44de-83b1-82dc20c643de",
    "hitokoto": "要不断的移动像水一样，才不会变成死水一样，你要不断流动着！",
    "type": "g",
    "from": "李小龙",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585557357",
    "length": 29
  },
  {
    "id": 5416,
    "uuid": "5c7be742-4d41-48f5-8efd-12bf4ac50ae4",
    "hitokoto": "当某天，雨点轻敲你窗，当风声吹乱你构想，可否抽空想这张，旧模样。",
    "type": "g",
    "from": "千千阙歌",
    "from_who": "林振强",
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585817500",
    "length": 32
  },
  {
    "id": 5423,
    "uuid": "c1214f54-24a8-4a15-baa6-857ef0ad9dd5",
    "hitokoto": "彼此这么了解，难怪注定似兄妹一对。",
    "type": "g",
    "from": "钟无艳",
    "from_who": "林夕",
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585818346",
    "length": 17
  },
  {
    "id": 5426,
    "uuid": "05c325ec-364a-4d18-be7c-a4b00da491fa",
    "hitokoto": "愿你有一天能和你最重要的人重逢。",
    "type": "g",
    "from": "可塑性记忆的影评",
    "from_who": "水水若空",
    "creator": "sjfhsjfh",
    "creator_uid": 4997,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585632299",
    "length": 16
  },
  {
    "id": 5954,
    "uuid": "8b0819a4-1774-4b75-a604-285cf89a4f0e",
    "hitokoto": "开始的倾心交谈，沦为平淡。",
    "type": "g",
    "from": "《与我无关》",
    "from_who": "阿冗",
    "creator": "晚柠",
    "creator_uid": 5345,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586564028",
    "length": 13
  },
  {
    "id": 5964,
    "uuid": "04386388-fcb9-4a4c-93dc-1475b85a61b6",
    "hitokoto": "你的眼中，明暗交杂，一笑生花。",
    "type": "g",
    "from": "起风了",
    "from_who": "米果",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587108705",
    "length": 15
  },
  {
    "id": 5986,
    "uuid": "a7f4cb17-8409-4cce-b416-f3d55191de90",
    "hitokoto": "如果喜欢和合适撞个满怀多好。",
    "type": "g",
    "from": "不待",
    "from_who": "契约千魂",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341544",
    "length": 14
  },
  {
    "id": 6000,
    "uuid": "9a24022a-b6b1-42c9-b82d-b0ec5482902a",
    "hitokoto": "吾志所向，一往无前，愈挫愈奋，再接再厉。",
    "type": "g",
    "from": "孙中山",
    "from_who": "孙中山",
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586362439",
    "length": 20
  },
  {
    "id": 6001,
    "uuid": "67e59764-fbec-4245-96e6-1f7382ee5497",
    "hitokoto": "The only way to get rid of a temptation is to yield to it. I can resist everything except temptation.",
    "type": "g",
    "from": "王尔德",
    "from_who": "王尔德",
    "creator": "清秋拂依",
    "creator_uid": 5838,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586401555",
    "length": 101
  },
  {
    "id": 6004,
    "uuid": "5b2cd23f-21e8-421d-90d5-522126a24de0",
    "hitokoto": "在人间有谁活着不像是一场炼狱，我不哭我已经没有尊严能放弃。",
    "type": "g",
    "from": "在人间",
    "from_who": "王建房",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586500363",
    "length": 29
  },
  {
    "id": 6102,
    "uuid": "bf72e92d-d75f-4973-b157-1fc714835cf9",
    "hitokoto": "假如失去追寻的动力，人类将消失在永恒的黑暗中。",
    "type": "g",
    "from": "深い森",
    "from_who": "Do As Infinity",
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588646543",
    "length": 23
  },
  {
    "id": 6103,
    "uuid": "52085af3-6045-46b2-8516-0bcb901ccbb6",
    "hitokoto": "他们想要的成熟我想不通，他们嘴里的软弱我听不懂.",
    "type": "g",
    "from": "不愿回头",
    "from_who": "南征北战",
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588648090",
    "length": 24
  },
  {
    "id": 6114,
    "uuid": "58a0a4c7-c721-4127-b1f3-3a48a1f772b4",
    "hitokoto": "若是我笑得皮开又肉绽，就莫问，离合悲欢。",
    "type": "g",
    "from": "至尊宝",
    "from_who": "徐良",
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588590960",
    "length": 20
  },
  {
    "id": 6138,
    "uuid": "86c372f0-b223-4469-af3a-4515a6d9f15b",
    "hitokoto": "遇到问题沉默是人的本能，沉默过后怎么解决是人的选择。毫不在意不是冷酷无情，不管他们怎么选择，这与你无关。",
    "type": "g",
    "from": "罪犯请沉默",
    "from_who": "迷羔羊",
    "creator": "AMU",
    "creator_uid": 6407,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591446575",
    "length": 52
  },
  {
    "id": 6157,
    "uuid": "b8039b2e-4146-4ab7-9f8d-bb8ab511df35",
    "hitokoto": "是谁来自山川湖海，却囿于昼夜厨房与爱。",
    "type": "g",
    "from": "揪心的玩笑与漫长的白日梦",
    "from_who": "姬赓",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589356568",
    "length": 19
  },
  {
    "id": 6158,
    "uuid": "db94d09a-8866-494b-aa3d-53ad8051d526",
    "hitokoto": "夜来草木见露水，鸿雁南渡避寒。",
    "type": "g",
    "from": "雪中悍刀行",
    "from_who": "烽火戏诸侯",
    "creator": "本事",
    "creator_uid": 6206,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589357425",
    "length": 15
  },
  {
    "id": 6206,
    "uuid": "5f0138e9-1043-454e-84ef-33ef9617e2a3",
    "hitokoto": "前程莫怕无知已，只怕每天只有404。",
    "type": "g",
    "from": "IT程序员",
    "from_who": "云歌",
    "creator": "yunge",
    "creator_uid": 2797,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590851823",
    "length": 18
  },
  {
    "id": 6257,
    "uuid": "e17462fe-8956-49a0-9de0-f99fbc6ec5cd",
    "hitokoto": "我们学哲学是为了什么？应该是为了明白我们向死而生的这一辈子应该怎么过。",
    "type": "g",
    "from": "我的一位老师",
    "from_who": "生活",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592126146",
    "length": 35
  },
  {
    "id": 6266,
    "uuid": "ccf80bf9-875f-4ce4-a82f-a4b582505e9c",
    "hitokoto": "不要因为结束而哭泣，要因它发生过而欣喜。",
    "type": "g",
    "from": "打开一颗心",
    "from_who": "西奥多·苏斯·盖泽尔（苏斯博士）",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592124827",
    "length": 20
  },
  {
    "id": 6272,
    "uuid": "9103a2c8-a820-4a2c-9d68-4251408f9d4d",
    "hitokoto": "哦~我的老伙计，祝你度过有意义的一天~!",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "无脑僵",
    "creator_uid": 6154,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592095655",
    "length": 20
  },
  {
    "id": 6274,
    "uuid": "96587453-191d-43bf-9204-441dbf082e44",
    "hitokoto": "现在的我，未来的我，一起去啊，更远的地方！",
    "type": "g",
    "from": "伪装学渣",
    "from_who": "木瓜黄",
    "creator": "07",
    "creator_uid": 6228,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592025834",
    "length": 21
  },
  {
    "id": 6314,
    "uuid": "8b1b41ea-b4df-4ba5-82e6-c348d9c5326c",
    "hitokoto": "心中多少的沧桑，不可抵挡的空虚，卑躬屈膝的一生，今天必须冲出那枷锁，就要像狂人，呼叫响震天！",
    "type": "g",
    "from": "金属狂人",
    "from_who": "黄家驹",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982161",
    "length": 46
  },
  {
    "id": 6315,
    "uuid": "3da378b2-e0dd-465d-93a6-1c41bfc27980",
    "hitokoto": "你可以怪我甚至可以骗我，不过你绝不可以把我当初哥。",
    "type": "g",
    "from": "初哥",
    "from_who": "黄贯中",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982194",
    "length": 25
  },
  {
    "id": 6316,
    "uuid": "0d571fa5-5933-40db-a628-3113b44d9d80",
    "hitokoto": "于是悲欢起落人静默，等一等这些伤会自由。",
    "type": "g",
    "from": "口是心非",
    "from_who": "张雨生",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982247",
    "length": 20
  },
  {
    "id": 6317,
    "uuid": "5e8b1c59-9ee7-4ad9-a682-c8abd56f060c",
    "hitokoto": "你盏教坏细路，脑袋注定发霉，赈灾当做节目，点解叫座叫好。",
    "type": "g",
    "from": "教坏细路",
    "from_who": "beyond",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982272",
    "length": 28
  },
  {
    "id": 6318,
    "uuid": "668f33a4-dabf-4a60-8ab1-41692eebcd7b",
    "hitokoto": "共你热恋可抵挡冰天雪地，共你拥抱能忘掉名利，没有一个人在可以媲美。",
    "type": "g",
    "from": "无得比",
    "from_who": "黄贯中",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982468",
    "length": 33
  },
  {
    "id": 6319,
    "uuid": "41987777-fb60-4738-bf78-135f0b0b4147",
    "hitokoto": "我不自觉 跌进这一角落 来去的拉拖 错过再错过 我不认错 纵我听不到附和 谁也都清楚。",
    "type": "g",
    "from": "睡火山",
    "from_who": "黄贯中",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592982659",
    "length": 43
  },
  {
    "id": 6342,
    "uuid": "1d035a10-9f66-4eb7-bb09-66751c709913",
    "hitokoto": "幽暗，让我们向往光明。",
    "type": "g",
    "from": "罗翔",
    "from_who": "罗翔",
    "creator": "我一点也不胖",
    "creator_uid": 6705,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594731723",
    "length": 11
  },
  {
    "id": 6364,
    "uuid": "000142a0-a5f7-43eb-b723-1ec7163edc95",
    "hitokoto": "小时候我会做1加1等于2，而邻居家的大哥哥会做1万加1万等于2万。他居然可以做到那么大的数字，我很佩服。他还说，等他上了大学就可以知道1亿加1亿是多少了。",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "无昵称",
    "creator_uid": 6645,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594045236",
    "length": 77
  },
  {
    "id": 6365,
    "uuid": "5cf97c7e-203a-4867-af46-cff972446f06",
    "hitokoto": "无伤大雅。",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "懒猫猫",
    "creator_uid": 6647,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594084460",
    "length": 5
  },
  {
    "id": 6370,
    "uuid": "2aefce17-d60f-4faf-81c8-1150229973af",
    "hitokoto": "如果你觉得黑暗，那你就做黑暗中的一盏光吧。",
    "type": "g",
    "from": "罗翔",
    "from_who": "罗翔",
    "creator": "我一点也不胖",
    "creator_uid": 6705,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594731520",
    "length": 21
  },
  {
    "id": 6371,
    "uuid": "24b66918-26b4-46b1-81ec-e0b1db0a18f9",
    "hitokoto": "看惯黑夜的人不应该习惯黑夜，而应该更习惯光明。",
    "type": "g",
    "from": "罗翔说刑法",
    "from_who": "罗翔",
    "creator": "bobwxc",
    "creator_uid": 6706,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594733982",
    "length": 23
  },
  {
    "id": 6373,
    "uuid": "71d87dc6-66eb-44c0-bb4b-d5cb67f1a2a0",
    "hitokoto": "Those who believe without reason cannot be convinced by reason.",
    "type": "g",
    "from": "JamesRandi",
    "from_who": "-JamesRandi, magician and skeptic (b. 7 Aug 1928)",
    "creator": "Aaron",
    "creator_uid": 6664,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594292375",
    "length": 63
  },
  {
    "id": 6375,
    "uuid": "744dd2e5-c1c2-45f0-87eb-678cae7a81ba",
    "hitokoto": "看惯黑夜的人，不应该习惯黑夜，而是应该期待黑夜中的光明。",
    "type": "g",
    "from": "罗翔",
    "from_who": "罗翔",
    "creator": "我一点也不胖",
    "creator_uid": 6705,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594731290",
    "length": 28
  },
  {
    "id": 6391,
    "uuid": "eb251958-1d79-4059-a67e-ac57f367865b",
    "hitokoto": "不是为了要求你做些什么才生下你，而是想为你做些什么才生下了你。",
    "type": "g",
    "from": "空间",
    "from_who": "佚名",
    "creator": "Lakr233",
    "creator_uid": 6834,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596083800",
    "length": 31
  },
  {
    "id": 6392,
    "uuid": "1f811708-9f23-4a1c-843f-7d3a0e13138c",
    "hitokoto": "战争只在历史书籍历书写了四页，却撕掉了将近一半的世界。",
    "type": "g",
    "from": "Hold my hand",
    "from_who": "MC光光、法老",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596108512",
    "length": 27
  },
  {
    "id": 6393,
    "uuid": "ecf305d6-eaba-4693-87a3-b711591ce6b5",
    "hitokoto": "时间是美好的，他让我们相遇；时间也是混蛋的，他又让我们分别。",
    "type": "g",
    "from": "一张卡片",
    "from_who": "张同学",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596107598",
    "length": 30
  },
  {
    "id": 6404,
    "uuid": "9ada51c2-b5aa-4283-a4a6-6ae0e4bc4ff4",
    "hitokoto": "OH LADY，可否将我带返去你屋企，日夜陪你，红橙色，勾出的你，你使我记不清，坐或是企。",
    "type": "g",
    "from": "LADY",
    "from_who": "黄贯中",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595523823",
    "length": 45
  },
  {
    "id": 6406,
    "uuid": "77a6462c-f262-4abf-9c50-9d438314468f",
    "hitokoto": "我要和天一样高，寻找一种魅力的情操，我要和天一样高，一样高，我的未来才能看得到。",
    "type": "g",
    "from": "和天一样高",
    "from_who": "张雨生",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595523172",
    "length": 40
  },
  {
    "id": 6409,
    "uuid": "c8c0a7a2-8f00-408b-bcfa-ced794b3a53e",
    "hitokoto": "每个人都应该学会如何编程，因为它教会你如何思考。",
    "type": "g",
    "from": "史蒂夫·乔布斯",
    "from_who": "史蒂夫·乔布斯",
    "creator": "suxin",
    "creator_uid": 6790,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595592954",
    "length": 24
  },
  {
    "id": 6419,
    "uuid": "f2b12061-9a73-4dba-8a8e-7510ae8bcce0",
    "hitokoto": "我对音乐并没有很特别的感觉。只是，有的时候，我突然因某段乐音而得到慰解；有的时候，我仿佛能与某些小节灵犀相通，有的时候，我身体的某一部份似乎也同样起了与那位歌者类似的悸动或什么的，我也不太能抓得准。",
    "type": "g",
    "from": "如燕盘旋而来的思念",
    "from_who": "张雨生",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596122258",
    "length": 99
  },
  {
    "id": 6423,
    "uuid": "7b8a02ba-caeb-4eb8-bf7a-59a9d8c17bc0",
    "hitokoto": "我希望海水还是蓝的，仰望天空时太阳不是灰的，与爱的联络不是靠电子产品，希望穿山甲不是博物馆的展品。",
    "type": "g",
    "from": "Hold my hand",
    "from_who": "MC光光、法老",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596108850",
    "length": 49
  },
  {
    "id": 6437,
    "uuid": "051823c1-f9ed-4368-ba3c-6f9dfcc7bc57",
    "hitokoto": "情到深处人孤独。",
    "type": "g",
    "from": "生活",
    "from_who": null,
    "creator": "情绪化",
    "creator_uid": 6967,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1597544307",
    "length": 8
  },
  {
    "id": 6446,
    "uuid": "760b328d-6d5b-4480-8680-f7dfb2cb2757",
    "hitokoto": "我要荣耀向我俯首称臣，征服世界或一无所有。",
    "type": "g",
    "from": "荣耀向我俯首",
    "from_who": "空儿卡",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596764619",
    "length": 21
  },
  {
    "id": 6456,
    "uuid": "0c627f5d-708a-4aeb-b843-e3faf0370e24",
    "hitokoto": "所以当你迷茫的时候，至少要笑着原谅自己，因为不被使用的心总有一天会枯萎。",
    "type": "g",
    "from": "九番目の迷路",
    "from_who": "アリスシャッハと魔法の楽団",
    "creator": "xiong_6",
    "creator_uid": 6953,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597399012",
    "length": 36
  },
  {
    "id": 6458,
    "uuid": "0a47f2ff-c33a-4689-b0d7-2a8652e35d26",
    "hitokoto": "岁月，你别催，该来的我不推。岁月，你别催，走远的仍要追。当不得不说再见的时候，挥别的那一刻就如同流水的光阴，谁能抵得过？谁能叹息？奈何！",
    "type": "g",
    "from": "天下足球",
    "from_who": null,
    "creator": "流幻的光",
    "creator_uid": 7468,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602838177",
    "length": 68
  },
  {
    "id": 6589,
    "uuid": "7b6e5172-9bcd-445d-b2cd-70cf17cea0a1",
    "hitokoto": "现实没有reset bottom, 没有extra life, 没有代打上分,没有游戏删挡再重来。",
    "type": "g",
    "from": "头号玩家",
    "from_who": "老番茄",
    "creator": "那隻喵",
    "creator_uid": 7495,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603106257",
    "length": 49
  },
  {
    "id": 6610,
    "uuid": "c4d0c0df-2f05-4706-a39a-b337e2db6190",
    "hitokoto": "卡布奇诺今犹在，不见当年吃屏人。",
    "type": "g",
    "from": "网络",
    "from_who": "皮皮参",
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603724726",
    "length": 16
  },
  {
    "id": 6618,
    "uuid": "f99d1731-b651-4ef8-9ce4-a7e4817fde0f",
    "hitokoto": "I only wanted you 'cause I couldn't have you.",
    "type": "g",
    "from": "Hope",
    "from_who": "The Chainsmokers, Winona Oak",
    "creator": "River",
    "creator_uid": 7613,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604156219",
    "length": 45
  },
  {
    "id": 6630,
    "uuid": "dcb7cc29-8b67-43c4-b053-c9b467582656",
    "hitokoto": "我的容身之所，就是你的身边。",
    "type": "g",
    "from": "理与迷宫的少女",
    "from_who": "夏彦深见",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1612429060",
    "length": 14
  },
  {
    "id": 6657,
    "uuid": "ce73ea38-1c07-410f-9c3e-32f20308ad8a",
    "hitokoto": "最后再来做个约定吧。一定会再次与你相遇......",
    "type": "g",
    "from": "理与迷宫的少女",
    "from_who": "夏彦深见",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612429214",
    "length": 25
  },
  {
    "id": 6658,
    "uuid": "7b70080a-d6f9-49a2-b31d-8affd68b00be",
    "hitokoto": "确定反应，调整守恒。",
    "type": "g",
    "from": "bilibili",
    "from_who": "某位化学老师的课",
    "creator": "Oneton",
    "creator_uid": 7556,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1603678669",
    "length": 10
  },
  {
    "id": 6737,
    "uuid": "843dcc96-da72-4804-bec6-786406d8f31a",
    "hitokoto": "你在天空之下欢声笑语，却独留我一人呆在黑暗里不自信。",
    "type": "g",
    "from": "原创",
    "from_who": "Naya",
    "creator": "Naya",
    "creator_uid": 7785,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605722129",
    "length": 26
  },
  {
    "id": 6738,
    "uuid": "e3954841-d43c-4133-815b-6b86ad0b444b",
    "hitokoto": "因为太害怕失去，所以才将苦痛剥离。",
    "type": "g",
    "from": "原创",
    "from_who": "Naya",
    "creator": "Naya",
    "creator_uid": 7785,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605722174",
    "length": 17
  },
  {
    "id": 6751,
    "uuid": "337b159c-5485-47f5-83c4-646a58f44d39",
    "hitokoto": "川端康成自杀， 在送往医院急救的途中， 对司机说了最后一句话： “路这么挤，辛苦你了”。",
    "type": "g",
    "from": "网络",
    "from_who": null,
    "creator": "古いいい日",
    "creator_uid": 7856,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606309273",
    "length": 44
  },
  {
    "id": 6774,
    "uuid": "55d85c9e-511e-4c76-a24b-b48f3ad36118",
    "hitokoto": "I think I speak very poor English, but anyway I dare to say. This is very important.",
    "type": "g",
    "from": "江泽民",
    "from_who": null,
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606404446",
    "length": 84
  },
  {
    "id": 6794,
    "uuid": "9bec85e2-4055-4c1c-b745-ac92e8167d74",
    "hitokoto": "无论别人说什么，你只要坚持自我就好了。",
    "type": "g",
    "from": "oioweb",
    "from_who": null,
    "creator": "Daiyangcheng",
    "creator_uid": 7801,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606566101",
    "length": 19
  },
  {
    "id": 6795,
    "uuid": "c0f4db09-0cee-4cb1-a855-bb9a74f03108",
    "hitokoto": "我终于发觉了自己迷茫的原因。我并不是缺少地图，我缺少的，是目的地。",
    "type": "g",
    "from": "oioweb",
    "from_who": null,
    "creator": "Daiyangcheng",
    "creator_uid": 7801,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606566352",
    "length": 33
  },
  {
    "id": 6805,
    "uuid": "b5e618f3-c161-4f11-9723-498d5e0ab1d4",
    "hitokoto": "在战略上要藐视敌人，在战术上要重视敌人！",
    "type": "g",
    "from": "毛泽东选集",
    "from_who": "毛主席",
    "creator": "鹿饮林空·",
    "creator_uid": 5643,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1618384160",
    "length": 20
  },
  {
    "id": 6809,
    "uuid": "4a515fe9-929b-4406-8525-9849799cf3eb",
    "hitokoto": "人是会交易的动物，狗是不会交换骨头的。",
    "type": "g",
    "from": "国富论",
    "from_who": null,
    "creator": "风言",
    "creator_uid": 8818,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1616686360",
    "length": 19
  },
  {
    "id": 6852,
    "uuid": "db9b7e0b-6daf-4f58-b0a7-b1a3bac3d7a7",
    "hitokoto": "大部分的生活都乏味得不值一提，根本就没有不乏味的时候。换另一种牌子的香烟也好，搬到一个新地方去住也好，订阅别的报纸也好，坠入爱河又脱身出来也好，我们一直在以或轻浮或深沉的方式，来对抗日常生活那无法消释的乏味成分。",
    "type": "g",
    "from": "杜鲁门·卡波特",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607220029",
    "length": 106
  },
  {
    "id": 6856,
    "uuid": "5c322745-725a-4cff-bda7-6a999ee98906",
    "hitokoto": "我们活过的刹那，前后皆是暗夜。",
    "type": "g",
    "from": "费尔南多·佩索阿",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266035",
    "length": 15
  },
  {
    "id": 6991,
    "uuid": "fbacaa04-a783-4377-abc2-215263f57185",
    "hitokoto": "台下人走过，不见旧颜色。",
    "type": "g",
    "from": "赤怜",
    "from_who": "等什么君",
    "creator": "热弦吉他",
    "creator_uid": 8369,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611901279",
    "length": 12
  },
  {
    "id": 7010,
    "uuid": "654156ec-baa3-40fb-85df-969faf1abdba",
    "hitokoto": "路难终乘鹏风起，瑶琴不歇为君啼。",
    "type": "g",
    "from": "原创",
    "from_who": "子公",
    "creator": "wsll子公",
    "creator_uid": 6971,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612325008",
    "length": 16
  },
  {
    "id": 7114,
    "uuid": "027d1241-91bd-4ffa-bdb0-a12ec92a4025",
    "hitokoto": "听得懂与聊得来多难得。",
    "type": "g",
    "from": "生活",
    "from_who": "lojoy",
    "creator": "lojoy",
    "creator_uid": 9006,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618309690",
    "length": 11
  },
  {
    "id": 7116,
    "uuid": "9bf11273-6b0f-4b4d-8349-a9760a398ef2",
    "hitokoto": "你和我说他的可爱，你和我说他的好看。恍惚间窥见在樱花树下，铁道边，一对少男少女彼此走着，风起花落拂过他们脸颊。",
    "type": "g",
    "from": "因为有你",
    "from_who": "祉语",
    "creator": "xhduoduobaby",
    "creator_uid": 7398,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618726438",
    "length": 55
  },
  {
    "id": 7133,
    "uuid": "ad8f35ec-cf8e-449b-a127-bcebe4853fb3",
    "hitokoto": "愿学术自由之风劲吹。",
    "type": "g",
    "from": "斯坦福大学校训",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614340298",
    "length": 10
  },
  {
    "id": 7166,
    "uuid": "fd1976c9-9fe5-4ad9-bf32-1e9c4c21e243",
    "hitokoto": "如果丢失是为了重新拾回失去之物，那么离别是为了能够再次相逢，道声珍重之后，我们一定能在未来再次向对方说声你好。",
    "type": "g",
    "from": "TOMORROW",
    "from_who": "恒松あゆみ",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614775659",
    "length": 55
  },
  {
    "id": 7192,
    "uuid": "fb912f80-700a-41a4-b030-58a42a2eab0f",
    "hitokoto": "我站在你左侧，却像隔着银河。",
    "type": "g",
    "from": "你不是真正的快乐",
    "from_who": "五月天",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031724",
    "length": 14
  },
  {
    "id": 7199,
    "uuid": "2220e406-b6bb-4bc1-b003-83bb2d8cba79",
    "hitokoto": "江东依旧，故国不在，天上的云是他，吹过耳畔的风是他 江水浪来浪去，朵朵浪花都是他，我看漫野山花，漫山遍野都是他，我行过万里河山，万里河山都是他。",
    "type": "g",
    "from": "灵魂摆渡黄泉篇",
    "from_who": "孙尚香",
    "creator": "澈亦",
    "creator_uid": 8678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615039122",
    "length": 72
  },
  {
    "id": 7207,
    "uuid": "d3033962-dd20-440c-b029-3931bef98bdf",
    "hitokoto": "黑暗的环境容易做错事。",
    "type": "g",
    "from": "学校",
    "from_who": "某中学数学老师",
    "creator": "roco",
    "creator_uid": 8685,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616598920",
    "length": 11
  },
  {
    "id": 7210,
    "uuid": "444762ad-18bf-443e-ad79-c734308f68c6",
    "hitokoto": "没有绝对的废物，只有放错位置的资源。",
    "type": "g",
    "from": "上海市垃圾分类",
    "from_who": "上海市垃圾分类",
    "creator": "雄鹰展翅",
    "creator_uid": 7520,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616257566",
    "length": 18
  },
  {
    "id": 7211,
    "uuid": "3cfabe10-91d1-455a-af65-2d9c59b90fee",
    "hitokoto": "刚好知交，刚好欢笑，刚好闪耀。",
    "type": "g",
    "from": "长大就好",
    "from_who": "陈亦洺",
    "creator": "一只上上签",
    "creator_uid": 8825,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616751141",
    "length": 15
  },
  {
    "id": 7360,
    "uuid": "d8ba4a59-5a4a-42c9-a6fb-cd983fcb9240",
    "hitokoto": "北树阴浓，青衣成风。",
    "type": "g",
    "from": "《这个王妃路子野，得宠！》",
    "from_who": "封侯拜饭",
    "creator": "BAIYANG",
    "creator_uid": 9573,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1624628045",
    "length": 10
  },
  {
    "id": 7387,
    "uuid": "33424268-2d56-486c-8848-75ba25a85ab5",
    "hitokoto": "数学分析？我已经完全掌握了。",
    "type": "g",
    "from": "魔法少女rqy",
    "from_who": "qhw",
    "creator": "Van nya",
    "creator_uid": 8353,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1618806208",
    "length": 14
  },
  {
    "id": 7389,
    "uuid": "8a0fbeff-1c38-46cc-941c-3af09c543b18",
    "hitokoto": "一等人，有本事，无脾气。二等人，有本事，有脾气。三等人，无本事，无脾气。四等人，无本事，大脾气。",
    "type": "g",
    "from": "一日禅",
    "from_who": null,
    "creator": "Nanachi",
    "creator_uid": 8880,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617382192",
    "length": 48
  },
  {
    "id": 7390,
    "uuid": "aeb884cf-961d-48a1-91e4-01a114702147",
    "hitokoto": "心灵被摧毁到模糊的情景、还认为是美丽的话，一定这样才是，生而为人的证据吧。",
    "type": "g",
    "from": "不可解",
    "from_who": "花谱",
    "creator": "Negative_Number",
    "creator_uid": 8887,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617451888",
    "length": 37
  },
  {
    "id": 7395,
    "uuid": "14cab9f6-b69e-498f-8f7f-3bb326d0e6fb",
    "hitokoto": "也许我或者“我们”，终有一天能自由地生存着。",
    "type": "g",
    "from": "清华THUPC 2020",
    "from_who": "清华THUPC出题方",
    "creator": "AtomAlpaca",
    "creator_uid": 8873,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617527533",
    "length": 22
  },
  {
    "id": 7475,
    "uuid": "0bed52ae-f294-44a3-bf09-8d3198375ddd",
    "hitokoto": "眉若远山，目运星河。",
    "type": "g",
    "from": "《源初幻想》",
    "from_who": "鹤空流乂",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627988349",
    "length": 10
  },
  {
    "id": 7491,
    "uuid": "d6350560-64fb-4f7f-934b-693d7c27d4cf",
    "hitokoto": "人生就是一场旅行，没有终点的这条路，和爱着的人肩并肩，寻找着梦的所在。",
    "type": "g",
    "from": "川の流れ(川流不息)",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629229667",
    "length": 35
  },
  {
    "id": 7492,
    "uuid": "004246a8-fce5-48a9-b42d-aa1d64ce809d",
    "hitokoto": "旧日爱人对我微笑，可他虽然对我微笑，却留我独处森林中，困倦让我进入梦乡，可对爱人无限的爱，却又让我重新醒来。",
    "type": "g",
    "from": "Kaar Deerge Chouvulangnig",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629230019",
    "length": 54
  }
]